import * as _ from "lodash";
import { BehaviorSubject } from "rxjs";
import { IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions } from "../PA.Core/PA.Core.IF.BO";
import { IHaveProductGroups, IHaveSecurity, IHaveTags } from "../PA.Core/PA.Core.IF.Aspects";
import { IProgressProvider, IMessageProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { IdentityProvider } from "../PA.Core/Basic/Identity";
import { ASync } from "../PA.Core/Basic/ASync";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import { ProgressProvider } from "../PA.Core/Basic/Progress";
import { TPMEventBOAudit } from "./TPMEventBO.Audit";
import { PAdbContext } from "../PA.Core/PAdbContext";
import {
    esWB_Plan,
    esWB_TPM_Event,
    esWB_TPM_Event_Tag,
    esWB_TPM_Event_Product_Group,
    esWB_TPM_Event_Product,
    esWB_TPM_Event_Metrics,
    esWB_TPM_Event_Spend,
    esWB_TPM_Event_Spend_Product_Group,
    esWB_TPM_Event_Spend_Product,
    esWB_TPM_Event_Spend_Metrics,
    esWB_Tag,
    esWB_Event_Type,
    esWB_Plan_Type,
    esWB_Period,
    esWB_Customer,
    esWB_Product_Hierarchy,
    esWB_Product_Group,
    esWB_Plan_Management,
    esWB_Finished_Product,
    esWB_Event_Spend_Type,
    esWB_TPM_Event_Product_Metrics,
    esWB_Event_Spend_Type_Relationship,
    esWB_BusinessUnit,
    esWB_TPM_Event_Spend_Customer, esWB_Hierarchy
} from "../PA.Core/PAdbSchema";

import {
    WB_PlanRow,
    WB_TPM_EventRow,
    WB_TPM_EventTagRow,
    WB_TPM_EventProductGroupRow,
    WB_TPM_EventProductRow,
    WB_TPM_EventMetricsRow,
    WB_TPM_EventSpendTypeRow,
    WB_TPM_EventSpendRow,
    WB_TPM_EventSpendPrdGrpRow,
    WB_ProductGroupRow,
    WB_TagRow,
    WB_FinishedProductRow,
    WB_EventTypeRow,
    WB_WorkflowStatusRow,
    WB_PeriodRow,
    WB_UserRow,
    WB_TPM_EventSpendPrdRow,
    WB_TPM_EventProductMetricsRow,
    WB_PlanVolumeMetricsRow,
    WB_EventSpendTypeRelationshipRow, WB_HierarchyRow
} from "../PA.Core/PAdbSchemaRows";

import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { PAusrContext } from "../PA.Core/PAusrContext";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { TagBag } from "../PA.Utils/TagBag";
import {
    IHaveTPMEventMetrics,
    IHaveTPMEventMetricsChangedEvent,
    ITPMEventCalculator,
    IHaveTPMEventCalculator,
    ITPMEvent,
    ITPMEventChangedEvent,
    ITPMEventProductChangedEvent,
    ITPMEventProductGroupChangedEvent,
    ITPMEventProductGroups,
    ITPMEventProducts,
    ITPMEventProductsAddOptions,
    ITPMEventProductsAddOptionsDefaults,
    IHaveTPMEventStandardCalculator,
    ITPMEventStandardCalculator,
    ITPMEventProductsRemoveOptions,
    ITPMEventProductGroupsAddOptions,
    ITPMEventProductGroupsRemoveOptions,
    IHaveTPMEventProductMetrics,
    IHaveTPMEventProductMetricsChangedEvent
} from "../PA.TPM.Core/PA.TPM.IF.TPM.Event.Aspects";
import { ProductHierarchyService } from "../PA.MD.Services/ProductHierarchyService";
import { TPMEventStandardCalculator } from "../PA.TPM.Services/TPMEventStandardCalculator";
import { TPMEventCalculator } from "../PA.TPM.Services/TPMEventCalculator";
import {
    IHaveTPMEventSpend,
    ITPMEventSpend,
    ITPMEventSpendAddOptions,
    ITPMEventSpendAddOptionsDefaults
} from "../PA.TPM.Core/PA.TPM.IF.TPM.EventSpend.Aspects";
import { TPMEventSpend } from "./TPMEventBO.ITPMEventSpend";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { PolicyCollection } from "../PA.Core/Security/PolicyCollection";
import { PolicyBOis } from "../PA.Core/Security/PolicyBOis";
import { PolicyHasRole } from "../PA.Core/Security/PolicyHasRole";
import { TPMEventBOValidations } from "./TPMEventBO.validations";
import { IHaveWorkflow, IWorkflowProcessor } from "../PA.Core/PA.Core.IF.Workflow";
import { WorkflowProcessor } from "../PA.Core/Workflow/WorkflowProcessor";
import { TPMEventBOStandardWorkflowExtension } from "./TPMEventBO.StdWorkflowExt";
import { TPMEventBOStandardPolicy } from "./TPMEventBO.StdPolicy";
import { WorkflowStatusService } from "../PA.MD.Services/WorkflowStatusService";
import { TPMEventOffInvoiceUtils } from "./TPMEventOffInvoiceUtils";
import { IHaveSpendHistory, ITPMSpendState, SpendHistory_get } from "./TPMEventSpendHistory";
import { AuditService } from "../PA.Core/Security/AuditService";
import { PeriodService } from "../PA.MD.Services/PeriodService";
import { ExecutionSerializer } from "../PA.Core/Basic/ExecutionSerializer";

import { IHaveEditorLock, ILock, ILockOptions } from "../PA.Concurrency.Core/PA.Concurrency.IF.Lock";
import { PALockClient } from "../PA.Concurrency.Services/PALockClient";
import { IHaveRefCounter, IRefCounter } from "../PA.Concurrency.Core/PA.Concurrency.IF.RefCounter";
import { RefCounter } from "../PA.Concurrency.Core/RefCounter";
import { Subscription } from "rxjs/Subscription";
import { DefaultChanges } from "../PA.Core/BusinessObject/BusinessObjectChanges";
import { HierarchyStructureManager } from "../PA.MD.Hierarchy/HierarchyStructureManager";
import { IHierarchyStructure, IHierarchyStructureNavigator, INode } from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import { HierarchyStructureNavigator } from "../PA.MD.Hierarchy/HierarchyStructureNavigator";
import { reject } from "async";
import { ExceptionMessage_restate } from '../PA.Core/Basic/MessageUtils'

//<editor-fold desc = "Event BO Options Interface and Defaults ">

export interface ITPMEventCreateOptions {
    bEagerLoadAspectInterfaces?: boolean;
    bSkipLock?: boolean; // if to skip the lock. True for Tactic refresh, since it's running in a server process and updating non-user input fields
    dbContext?: PAdbContext;
}

export interface ITPMEventCopyOptions {
    wbPlanId?: number;
}

const TPMEventCreateOptions_default: ITPMEventCreateOptions = {
    bEagerLoadAspectInterfaces: true,
    bSkipLock: false
};

export interface ITPMEventLoadOptions {
    dbContext?: PAdbContext;
}

const TPMEventLoadOptions_default: ITPMEventLoadOptions = {};

export interface ITPMEventSaveValidateOptions {
    Validate?: {
        bSkipAllValidations?: boolean;
    };
    Save?: {
        bSkipWorkflowProcessing?: boolean;
    };
}

const TPMEventSaveValidateOptions_default: ITPMEventSaveValidateOptions = {
    Validate: {
        bSkipAllValidations: false
    },
    Save: {}
};

export interface ITPMEventDeleteOptions {
}

const TPMEventDeleteOptions_default: ITPMEventDeleteOptions = {};

const TPMEventCopyOptions_default: ITPMEventCopyOptions = {};

const EventMetrics_ProductGroupLoadAllThreshold = 15;

//</editor-fold desc>

export class TPMEventBO
    implements IBusinessObject,
        ITPMEvent,
        ITPMEventProductGroups,
        ITPMEventProducts,
        IHaveProductGroups,
        IHaveTPMEventCalculator,
        IHaveTPMEventStandardCalculator,
        IHaveTPMEventSpend,
        IHaveSecurity,
        IHaveTPMEventMetrics,
        IHaveWorkflow,
        IHaveSpendHistory,
        IHaveEditorLock,
        IHaveTPMEventProductMetrics,
        IHaveRefCounter {
    // IRecordResolverProvider  <static>
    //<editor-fold desc = "TPM Event Attributes and Constructor">

    CreateOptions: ITPMEventCreateOptions;
    CopyOptions: ITPMEventCopyOptions;
    Identity: IdentityProvider;

    LoadOptions: ITPMEventLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    _bIsLoadedInternal: boolean;
    _OnLoadCompleteInternal: Promise<TPMEventBO>;
    LoadProgressProvider: IProgressProvider;

    _OnReloaded: BehaviorSubject<TPMEventBO>;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_TPMEvent: WB_TPM_EventRow;

    usrContext: PAusrContext;

    dctAuditedDeletes: { [id: number]: number };
    dctAuditedCopy: { [id: string]: string };

    constructor(options?: ITPMEventCreateOptions) {
        this.CreateOptions = options || {};
        _.defaults(this.CreateOptions, TPMEventCreateOptions_default);

        if ("dbContext" in this.CreateOptions) {
            this.dbContext = this.CreateOptions.dbContext;
        }

        this.usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
        this.Identity = new IdentityProvider({ id: 0, name: "Undefined TPM Event" });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._bIsLoadedInternal = false;

        this._OnLoadComplete = undefined;
        this._OnLoadCompleteInternal = undefined;
        this.LoadProgressProvider = new ProgressProvider("Loading", this);

        this._OnReloaded = new BehaviorSubject<TPMEventBO>(this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_TPMEvent = undefined;

        this.dctAuditedDeletes = {};

        this.ITPMEvent_init();
        this.ITPMEventProductGroups_init();
        this.ITPMEventProduct_init();
        this.IHaveProductGroups_init();
        this.IHaveTPMEventSpend_init();
        this.IHaveSecurity_init();
        this.IHaveTagsLoaded_init();
        this.IHaveEventStandardCalculator_init();
        this.IHaveEventCalculator_init();
        this.IHaveWorkflow_init();
        this.IHaveTPMEventMetrics_init();
        this.IHaveSpendHistory_init();
        this.IHaveTPMEventProductMetrics_init();
        this.RefCounter_Init();
        this.dctAuditedCopy = {};
    }

    //</editor-fold>

    get WB_TPMEvent(): WB_TPM_EventRow {
        return this.drWB_TPMEvent;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: any): Promise<IBusinessObject> {
        const self = this;
        //precheck promises.. to see if already loading..?

        self.LoadProgressProvider.start("Creating TPM Event");

        const createOpts = _.defaultsDeep({}, self.CreateOptions, options);

        self._OnLoadCompleteInternal = new Promise<TPMEventBO>((resolve, error) => {
            if (self.bIsLoaded) {
                // "Event already loaded.";
                resolve(self);
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, TPMEventLoadOptions_default);

            if ("dbContext" in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for new TPM Event.");
                return;
            }

            self.dbContext
                .createRecordWithKey(esWB_TPM_Event)
                .then((newRecord: WB_TPM_EventRow) => {
                    self.dbContext.add(esWB_TPM_Event, newRecord);
                    self.drWB_TPMEvent = newRecord;

                    self.Identity.listenToRecordUpdates(self.WB_TPMEvent, "WB_TEVT_ID", "EVENT_ID", "EVENT_NAME");
                    self.drWB_TPMEvent.cif.WB_PLAN_ID = createOpts.PlanId;
                    self.drWB_TPMEvent.cif.WB_EVTTYPE_ID = createOpts.EventTypeId;
                    self.drWB_TPMEvent.cif.EVENT_NAME = createOpts.EventName;
                    self.drWB_TPMEvent.cif.WB_AUTHUSR_ID_CREATEDBY = createOpts.CreatedBy;
                    // must load the same as RecordResolver
                    //  [esWB_Event_Type]: [esWB_Tag, esWB_Product_Hierarchy ],
                    //  [esWB_Plan]:       [esWB_Plan_Type,  esWB_Customer, esWB_Product_Group, esWB_Period, esWB_Plan_Management ]

                    //return self.drWB_TPMEvent.loadRelations([esWB_Plan, esWB_Evet, esWB_Source])
                    self.drWB_TPMEvent.WB_UserRow_CreatedBy = self.usrContext.User;

                    self.Identity.setAll(
                        self.WB_TPMEvent.cif.WB_TEVT_ID,
                        self.WB_TPMEvent.cif.EVENT_ID,
                        self.WB_TPMEvent.cif.EVENT_NAME
                    );
                    self.LoadProgressProvider.setName(
                        "Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")"
                    );

                    return self.dbContext.find(esWB_Plan, self.drWB_TPMEvent.cif.WB_PLAN_ID);
                })
                .then((aPlanRow: WB_PlanRow) => {
                    self.drWB_TPMEvent.WB_PlanRow = aPlanRow;
                    return aPlanRow.loadRelations([
                        esWB_Plan_Type,
                        esWB_Customer,
                        esWB_Product_Group,
                        esWB_Period,
                        esWB_Plan_Management
                    ]);
                })
                .then((aPlanRow) => {
                    return aPlanRow.WB_PlanTypeRow.loadRelations([esWB_BusinessUnit]);
                })
                .then(() => {
                    return self.dbContext.find(esWB_Event_Type, self.drWB_TPMEvent.cif.WB_EVTTYPE_ID);
                })
                .then((anEventType: WB_EventTypeRow) => {
                    self.drWB_TPMEvent.WB_EventTypeRow = anEventType;
                    return anEventType.loadRelations([
                        esWB_Tag,
                        esWB_Product_Hierarchy,
                        esWB_Event_Spend_Type_Relationship
                    ]);
                })
                .then(() => {
                    // Get Initial Workflow State
                    if (self.drWB_TPMEvent.WB_EventTypeRow.cif.WORKFLOW_POLICY == "None") {
                        return ASync.resolve(undefined);
                    }
                    return WorkflowStatusService.getInitialWorkflowStatusByWorkflowWbID(
                        self.WB_TPMEvent.WB_EventTypeRow.cif.WB_WORKFLOW_ID
                    );
                })
                .then((aWorkflowStatus: WB_WorkflowStatusRow) => {
                    if (!_.isEmpty(aWorkflowStatus)) {
                        self.drWB_TPMEvent.cif.WORKFLOW_STATUS_ID = aWorkflowStatus.cif.WB_STATUS_ID;
                        self.drWB_TPMEvent.cif.WORKFLOW_STATUS_ID_NEXT = self.drWB_TPMEvent.cif.WORKFLOW_STATUS_ID;
                    }

                    // Initialize other fields
                    if (self.drWB_TPMEvent.WB_PlanRow) {
                        const planRow = self.drWB_TPMEvent.WB_PlanRow;
                        self.drWB_TPMEvent.cif.WB_CUST_ID_PLANNING = planRow.cif.WB_CUST_ID_PLANNING;
                        self.drWB_TPMEvent.cif.WB_CUST_ID_SUBPLANNING = planRow.cif.WB_CUST_ID_SUBPLANNING;

                        const periodRow = planRow.WB_PeriodRow;
                        const evtTypeRow = self.drWB_TPMEvent.WB_EventTypeRow;

                        if (evtTypeRow.bInStoreDatesShowInd) {
                            self.drWB_TPMEvent.cif.INSTORE_START_DT = periodRow.cif.PERIOD_START_DT;
                            self.drWB_TPMEvent.cif.INSTORE_END_DT = self.drWB_TPMEvent.cif.INSTORE_START_DT;
                        }

                        if (evtTypeRow.bShipmentDatesShowInd) {
                            self.drWB_TPMEvent.cif.SHIPMENT_START_DT = periodRow.cif.PERIOD_START_DT;
                            self.drWB_TPMEvent.cif.SHIPMENT_END_DT = self.drWB_TPMEvent.cif.SHIPMENT_START_DT;
                        }

                        if (evtTypeRow.bOrderDatesShowInd) {
                            self.drWB_TPMEvent.cif.ORDER_START_DT = periodRow.cif.PERIOD_START_DT;
                            self.drWB_TPMEvent.cif.ORDER_END_DT = self.drWB_TPMEvent.cif.ORDER_START_DT;
                        }

                        if (evtTypeRow.bDistributionDatesShowInd) {
                            self.drWB_TPMEvent.cif.DISTRIBUTION_START_DT = periodRow.cif.PERIOD_START_DT;
                            self.drWB_TPMEvent.cif.DISTRIBUTION_END_DT = self.drWB_TPMEvent.cif.DISTRIBUTION_START_DT;
                        }
                    }

                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            self._OnLoadCompleteInternal
                .then((aBO) => {
                    if (self.bIsLoaded) {
                        resolve(self);
                        return;
                    }

                    // Run after Load
                    self._bIsLoadedInternal = true;
                    self._OnLoadCompleteInternal = undefined;
                    self._AfterBoLoadCompleteInternal()
                        .then(() => {
                            self._bIsLoaded = true;
                            self._OnLoadComplete = undefined;
                            self.LoadProgressProvider.finish();
                            if (self.CreateOptions.bEagerLoadAspectInterfaces) {
                                self.OnIHaveProductGroupsLoaded;
                            }
                            resolve(self);
                        })
                        .catch((err) => {
                            self._OnLoadCompleteInternal = undefined;
                            self._OnLoadComplete = undefined;
                            self.LoadProgressProvider.exception(err);
                            resolve(err);
                        });
                })
                .catch((err) => {
                    self._OnLoadCompleteInternal = undefined;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    resolve(self);
                });
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadCompleteInternal = new Promise<TPMEventBO>((resolve, error) => {
            if (self.bIsLoaded) {
                resolve(self); // "TPM Event already loaded.";
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, TPMEventLoadOptions_default);

            if ("dbContext" in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for new TPM Event.");
                return;
            }

            if ("RecordResolver" in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve();
            } else {
                recordResolver = TPMEventBO.createRecordResolver({ dbContext: self.dbContext });
                recordResolverLoadPromise = TPMEventBO.setupRecordResolver(recordResolver, [anId]);
            }

            recordResolverLoadPromise
                .then(function() {
                    const aTPMEventRow: any = recordResolver.get(esWB_TPM_Event, anId);

                    if (_.isEmpty(aTPMEventRow)) {
                        console.log("TPM Event Record Resolver unable to locate TPMEvent for id: ", anId);
                        error("TPM Event not Found");
                        return;
                    }

                    self.drWB_TPMEvent = aTPMEventRow;
                    self.Identity.setAll(
                        self.WB_TPMEvent.cif.WB_TEVT_ID,
                        self.WB_TPMEvent.cif.EVENT_ID,
                        self.WB_TPMEvent.cif.EVENT_NAME
                    );
                    self.LoadProgressProvider.setName(
                        "Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")"
                    );
                    self.Identity.listenToRecordUpdates(self.WB_TPMEvent, "WB_TEVT_ID", "EVENT_ID", "EVENT_NAME");

                    return aTPMEventRow.WB_PlanRow.WB_PlanTypeRow.loadRelations([esWB_BusinessUnit]);
                })
                .then(() => {
                    resolve(self);
                })
                .catch(function(err: any) {
                    error(err);
                    return;
                });
        });

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            self._OnLoadCompleteInternal
                .then((aBO) => {
                    if (self.bIsLoaded) {
                        resolve(self);
                        return;
                    }

                    // Run after Load
                    self._bIsLoadedInternal = true;
                    self._OnLoadCompleteInternal = undefined;
                    self._AfterBoLoadCompleteInternal()
                        .then(() => {
                            self._bIsLoaded = true;
                            self._OnLoadComplete = undefined;
                            self.LoadProgressProvider.finish();

                            if (self.CreateOptions.bEagerLoadAspectInterfaces) {
                                self.OnIHaveProductGroupsLoaded;
                            }

                            resolve(self);
                        })
                        .catch((err) => {
                            self._OnLoadCompleteInternal = undefined;
                            self._OnLoadComplete = undefined;
                            self.LoadProgressProvider.exception(err);
                            resolve(err);
                        });
                })
                .catch((err) => {
                    self._OnLoadCompleteInternal = undefined;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    resolve(self);
                });
        });

        return this._OnLoadComplete;
    }

    private IBusinessObject_BeforeReload() {
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this._OnLoadCompleteInternal = undefined;
    }

    get OnReloaded(): BehaviorSubject<TPMEventBO> {
        return this._OnReloaded;
    }

    Reload(opts?: any): Promise<IBusinessObject> {
        const self = this;

        // TODO:  Review this.. thrown in here without review

        return new Promise<IBusinessObject>((resolve, error) => {
            if (!self.bIsLoaded) {
                error("Reload: TPM EventBO not loaded");
                return;
            }

            const id = self.WB_TPMEvent.cif.WB_TEVT_ID;

            self.dbContext
                .purgeCache(esWB_TPM_Event, self.WB_TPMEvent, {})
                .then(() => {
                    self._bIsLoaded = false;
                    self.IHaveTPMEventMetrics_beforeReload();
                    self.IHaveTPMEventProductMetrics_beforeReload();
                    self.IBusinessObject_BeforeReload();
                    self.IHaveEventCalculator_BeforeReload();
                    self.IHaveEventStandardCalculator_BeforeReload();
                    self.ITPMEvent_BeforeReload();
                    self.ITPMEventProductGroups_BeforeReload();
                    self.ITPMEventProducts_BeforeReload();
                    self.IHaveProductGroup_BeforeReload();
                    self.IHaveSecurity_BeforeReload();
                    self.IHaveTags_BeforeReload();
                    self.IHaveWorkflow_BeforeReload();
                    self.IHaveTPMEventSpend_BeforeReload();
                    self.IHaveSpendHistory_BeforeReload();
                    self.drWB_TPMEvent = undefined;

                    return self.Load(id, { dbContext: self.dbContext });
                })
                .then((aBO) => {
                    if (!aBO.bIsLoaded) {
                        console.log("Unable to Load BO in Reload function");
                    }

                    // Should we load any of the interfaces before firing Subjects ?
                    // kvd: rationalize this..

                    // Should we fire any existing Behavior Subjects?
                    self.ProductGroupsChanged.next(self);
                    self.TPMEventProductGroupCollectionChanged.next(self);
                    self.TPMEventProductCollectionChanged.next(self);
                    self.TPMEventSpendCollectionChanged.next(self);
                    self.TagsChanged.next(self);

                    async function RunAfterReload() {
                        for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
                            const aWfProcessor = self.WorkflowProcessors[idx];
                            await aWfProcessor.OnReloaded();
                        }
                    }

                    return RunAfterReload();
                })
                .then((aBO) => {
                    self.OnReloaded.next(self);
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        const tasks: Promise<any>[] = []
        self.LoadProgressProvider.setProgressMessage('TPMEventBO.PostLoad', 'Processing Loaded Data')
        tasks.push(self.ITPMEvent_OnLoadComplete())
        tasks.push(self.IHaveTPMEventMetrics_OnLoadComplete())
        tasks.push(self.ITPMEventProductGroups_OnLoadComplete())
        tasks.push(self.ITPMEventProducts_OnLoadComplete())
        tasks.push(self.IHaveTPMEventSpend_OnLoadComplete())
        await Promise.all(tasks)

        await self.IHaveWorkflow_OnLoadComplete()
        await self.IHaveEventStandardCalculator_OnLoadComplete()
        await self.IHaveEventCalculator_OnLoadComplete()
        await TPMEventOffInvoiceUtils.OESSentIndicator_setAggregateIndicators(self)
        await self.IHaveSpendHistory_OnLoadComplete()
        await self.IHaveSecurity_OnLoadComplete()
        if (!self.RefCounter.RefCount) self.RefCounter.acquireReference()

    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        if (this._bIsLoaded) {
            return ASync.resolve(this);
        }

        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    async Validate(options: ITPMEventSaveValidateOptions): Promise<IBusinessObject> {
        const self = this;

        try {
            self.ValidateMessageProvider.clearMessages()
            self.ValidateProgressProvider.start(
                'Validating ' + self.WB_TPMEvent.cif.EVENT_NAME + '(' + self.WB_TPMEvent.cif.EVENT_ID + ')'
            )


            options = options || {}
            _.defaultsDeep(options, TPMEventSaveValidateOptions_default)

            self.ValidateOptions = options

            if (_.isEmpty(self.dbContext)) {
                const sError = 'Unable to determine dbContext to Validate TPM Event.'
                self.ValidateProgressProvider.exception(sError)
                throw sError
            }

            await TPMEventBOValidations.Validate(self)

            if (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0) {
                for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
                    const aWfProcessor = self.WorkflowProcessors[idx]
                    await aWfProcessor.Validate()
                    self.ValidateMessageProvider.addMessages(aWfProcessor.WorkflowMessageProvider.Messages)
                }
            }

            self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
            self.ValidateProgressProvider.finish()
        } catch (err) {

            self._bIsValidated = false
            ExceptionMessage_restate(self.ValidateMessageProvider, err)
            self.ValidateProgressProvider.exception(err)

        }


        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    async Save(options?: ITPMEventSaveValidateOptions): Promise<IBusinessObject> {
        const self = this;

        // Add once Albert adds callback code into API
        // Create my own batch for this TPM Event Save..

        self.dbContext.BatchStart()
        // Add Lock Checked.. (API)
        //self.dbContext.BatchAddLockCheck(esWB_TPM_Event)
        // Save
        await self.SaveUsing(true, false, true, options)

        return self
    }

    SaveBatch(options?: ITPMEventSaveValidateOptions): Promise<IBusinessObject> {
        return this.SaveUsing(true, true, false, options);
    }

    private async SaveUsing(
        bUseBatchFunction: boolean,
        bUseBatchCallback: boolean,
        bCallBatchComplete: boolean,
        options?: ITPMEventSaveValidateOptions
    ): Promise<IBusinessObject> {
        const self = this

        this.SaveProgressProvider.start(
            'Saving ' + this.WB_TPMEvent.cif.EVENT_NAME + '(' + this.WB_TPMEvent.cif.EVENT_ID + ')'
        )

        if (!_.isEmpty(self.EditorLock) && self.EditorLock.Status === 'ReadOnly') {
            self._bIsSaved = false
            const sError = 'Unable to Save Locked TPM Event.'
            self.SaveProgressProvider.exception(sError)
            throw sError
        }

        if (_.isEmpty(self.dbContext)) {
            self._bIsSaved = false
            const sError = 'Unable to determine dbContext to Save TPM Event.'
            self.SaveProgressProvider.exception(sError)
            throw sError
        }

        try {

            options = options || {}
            _.defaultsDeep(options, TPMEventSaveValidateOptions_default)

            let saveFunction: (
                esName: string,
                saveRecords: ESRecord[] | ESRecord,
                options?: any
            ) => Promise<ESDataStore>
            if (bUseBatchFunction) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            self.SaveProgressProvider.setPercentComplete(0.1)

            if (options.Validate.bSkipAllValidations) {
                self._bIsValidated = true
            } else {
                await self.Validate(options)
            }


            if (!self.bIsValidated) {
                self._bIsSaved = false
                self.SaveProgressProvider.finish()
                return self
            }

            let auditService = await TPMEventBOAudit.TPMEventAuditBO(self)


            const tasks: Promise<any>[] = []

            const changeSet = self.Changes()
            if (
                _.filter(changeSet.Changes, (aChange) => aChange.Message.indexOf('WB_TPM_EvtPG') > 0).length ||
                _.filter(changeSet.Changes, (aChange) => aChange.Message.indexOf('WB_TPM_EvtPrd') > 0).length ||
                _.filter(changeSet.Changes, (aChange) => aChange.Message.indexOf('TPM_EvtSPG') > 0).length
            ) {
                self.WB_TPMEvent.cif.MODIFIED_DTTS = DateUtils.convertToSAPBWTs(new Date())
                _.forEach(self.WB_TPMEvent.WB_TPM_EventSpendRows, (aRow) => {
                    if (aRow.isActive) aRow.cif.MODIFIED_DTTS = DateUtils.convertToSAPBWTs(new Date())
                })
            }

            self.drWB_TPMEvent.WB_PlanRow.cif.MODIFIED_DTTS = DateUtils.convertToSAPBWTs(new Date())

            tasks.push(saveFunction(esWB_Plan, self.drWB_TPMEvent.WB_PlanRow))
            tasks.push(saveFunction(esWB_TPM_Event, self.drWB_TPMEvent))
            tasks.push(
                saveFunction(esWB_TPM_Event_Product_Group, self.drWB_TPMEvent.WB_TPM_EventProductGroupRows)
            )
            tasks.push(saveFunction(esWB_TPM_Event_Product, self.drWB_TPMEvent.WB_TPM_EventProductRows))

            tasks.push(saveFunction(esWB_TPM_Event_Tag, self.drWB_TPMEvent.WB_TPM_EventTagRows))

            tasks.push(saveFunction(esWB_TPM_Event_Spend, self.drWB_TPMEvent.WB_TPM_EventSpendRows))

            const arrSpendPGs = _.flatMap(
                self.TPMEventSpends,
                (aRow) => aRow.TPMEventSpendRow.WB_TPM_EventSpendPrdGrpRows
            )
            tasks.push(saveFunction(esWB_TPM_Event_Spend_Product_Group, arrSpendPGs))

            const arrSpendPrds = _.flatMap(
                self.TPMEventSpends,
                (aRow) => aRow.TPMEventSpendRow.WB_TPM_EventSpendPrdRows
            )
            tasks.push(saveFunction(esWB_TPM_Event_Spend_Product, arrSpendPrds))

            tasks.push(
                saveFunction(esWB_TPM_Event_Product_Metrics, self.drWB_TPMEvent.WB_TPM_EventProductMetricsRows)
            )

            await Promise.all(tasks)
            let bRunWorkflowProcessing = !(options?.Save?.bSkipWorkflowProcessing)
            if (bRunWorkflowProcessing) {

                for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
                    const aWfProcessor = self.WorkflowProcessors[idx]
                    await aWfProcessor.Save(bUseBatchFunction)
                }

                for (const iEventSpend of self.TPMEventSpends) {
                    const oEventSpend: TPMEventSpend = <any>iEventSpend
                    for (const aSpndWfProcessor of oEventSpend.WorkflowProcessors) {
                        await aSpndWfProcessor.Save(bUseBatchFunction)
                    }
                }
            }

            if (auditService)
                await auditService.Save(bUseBatchFunction)

            if (bUseBatchCallback) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true

                    if (bRunWorkflowProcessing)
                        self.AfterSaveCompleted()
                })
                self.SaveProgressProvider.finish()
                return (self)

            } else {
                self._bIsSaved = true
                if (bCallBatchComplete) {
                    await self.dbContext.BatchComplete()
                }
                if (bRunWorkflowProcessing)
                    await self.AfterSaveCompleted()

                self.SaveProgressProvider.finish()
                if (self.EditorLock)
                    self.EditorLock.touch().finally(() => {})
                return self
            }

        } catch (err) {
            self.SaveProgressProvider.exception(err)
        }

        return self

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    private async AfterSaveCompleted(): Promise<void> {
        const self = this;

        for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
            const aWfProcessor = self.WorkflowProcessors[idx];
            await aWfProcessor.OnSaved();
        }

        for (const iEventSpend of self.TPMEventSpends) {
            const oEventSpend: TPMEventSpend = <any>iEventSpend;
            for (const aSpndWfProcessor of oEventSpend.WorkflowProcessors) {
                await aSpndWfProcessor.OnSaved();
            }
        }
    }

    async Copy(options?: any): Promise<IBusinessObject> {
        const self: TPMEventBO = this;
        const copyOptions = _.defaultsDeep({}, self.CopyOptions, options);

        try {
            self.ValidateMessageProvider.clearMessages();
            let newTPMEventBO = new TPMEventBO({ dbContext: self.dbContext, bEagerLoadAspectInterfaces: false });
            const deletedPrdGrps: WB_ProductGroupRow[] = [];

            //check if the event is valid to be copied
            await TPMEventBOValidations.ValidateEventCopy(copyOptions.wbPlanId, self)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self.LoadProgressProvider.finish();
                return self;
            }

            newTPMEventBO = <TPMEventBO>await newTPMEventBO.LoadNew({
                dbContext: self.dbContext,
                PlanId: copyOptions.wbPlanId,
                EventTypeId: self.WB_TPMEvent.cif.WB_EVTTYPE_ID,
                EventName: self.WB_TPMEvent.cif.EVENT_NAME + " - Copy"
            })

            if (_.isEmpty(newTPMEventBO)) {
                self.LoadProgressProvider.finish();
                return self;
            }

            const prdGrps: IHaveProductGroups = await newTPMEventBO.OnIHaveProductGroupsLoaded;

            if (newTPMEventBO.bIsLoaded) {
                const tgtEvt = newTPMEventBO.WB_TPMEvent;
                tgtEvt.cif.ACTIVE_IND = self.WB_TPMEvent.cif.ACTIVE_IND;
                tgtEvt.cif.COVERAGE_FACTOR = self.WB_TPMEvent.cif.COVERAGE_FACTOR;
                tgtEvt.cif.INSTORE_START_DT = self.WB_TPMEvent.cif.INSTORE_START_DT;
                tgtEvt.cif.INSTORE_END_DT = self.WB_TPMEvent.cif.INSTORE_END_DT;
                tgtEvt.cif.SHIPMENT_START_DT = self.WB_TPMEvent.cif.SHIPMENT_START_DT;
                tgtEvt.cif.SHIPMENT_END_DT = self.WB_TPMEvent.cif.SHIPMENT_END_DT;
                tgtEvt.cif.ORDER_START_DT = self.WB_TPMEvent.cif.ORDER_START_DT;
                tgtEvt.cif.ORDER_END_DT = self.WB_TPMEvent.cif.ORDER_END_DT;
                tgtEvt.cif.DISTRIBUTION_START_DT = self.WB_TPMEvent.cif.DISTRIBUTION_START_DT;
                tgtEvt.cif.DISTRIBUTION_END_DT = self.WB_TPMEvent.cif.DISTRIBUTION_END_DT;
                tgtEvt.cif.WB_AUTHUSR_ID_CREATEDBY = self.usrContext.User.cif.WB_AUTHUSR_ID;
                tgtEvt.cif.WB_CUST_ID_SUBPLANNING = self.WB_TPMEvent.cif.WB_CUST_ID_SUBPLANNING;

                //resetting the dates according to the Plan being selected
                const offset: number = DateUtils.differenceInDays(
                    self.WB_TPMEvent.WB_PlanRow.WB_PeriodRow.PeriodStartDt,
                    tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodStartDt
                );

                tgtEvt.cif.INSTORE_START_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.InStoreStartDt, offset)
                );
                if (
                    DateUtils.isLessThan(
                        tgtEvt.InStoreStartDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodStartDt
                    )
                )
                    tgtEvt.cif.INSTORE_START_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_START_DT;

                tgtEvt.cif.INSTORE_END_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.InStoreEndDt, offset)
                );
                if (
                    DateUtils.isGreaterThan(
                        tgtEvt.InStoreEndDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodEndDt
                    )
                )
                    tgtEvt.cif.INSTORE_END_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_END_DT;

                tgtEvt.cif.SHIPMENT_START_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.ShipmentStartDt, offset)
                );
                if (
                    DateUtils.isLessThan(
                        tgtEvt.ShipmentStartDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodStartDt
                    )
                )
                    tgtEvt.cif.SHIPMENT_START_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_START_DT;

                tgtEvt.cif.SHIPMENT_END_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.ShipmentEndDt, offset)
                );
                if (
                    DateUtils.isGreaterThan(
                        tgtEvt.ShipmentEndDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodEndDt
                    )
                )
                    tgtEvt.cif.SHIPMENT_END_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_END_DT;

                tgtEvt.cif.ORDER_START_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.OrderStartDt, offset)
                );
                if (
                    DateUtils.isLessThan(
                        tgtEvt.OrderStartDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodStartDt
                    )
                )
                    tgtEvt.cif.ORDER_START_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_START_DT;

                tgtEvt.cif.ORDER_END_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.OrderEndDt, offset)
                );
                if (
                    DateUtils.isGreaterThan(
                        tgtEvt.OrderEndDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodEndDt
                    )
                )
                    tgtEvt.cif.ORDER_END_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_END_DT;

                tgtEvt.cif.DISTRIBUTION_START_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.DistributionStartDt, offset)
                );
                if (
                    DateUtils.isLessThan(
                        tgtEvt.DistributionStartDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodStartDt
                    )
                )
                    tgtEvt.cif.DISTRIBUTION_START_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_START_DT;

                tgtEvt.cif.DISTRIBUTION_END_DT = DateUtils.convertToSAPBW(
                    DateUtils.addDays(tgtEvt.DistributionEndDt, offset)
                );
                if (
                    DateUtils.isGreaterThan(
                        tgtEvt.DistributionEndDt,
                        tgtEvt.WB_PlanRow.WB_PeriodRow.PeriodEndDt
                    )
                )
                    tgtEvt.cif.DISTRIBUTION_END_DT = tgtEvt.WB_PlanRow.WB_PeriodRow.cif.PERIOD_END_DT;

                const arrValidPrdGrps: WB_ProductGroupRow[] = newTPMEventBO.AllProductGroups;
                const dctValidPrdGrps = _.keyBy(
                    arrValidPrdGrps,
                    (aPrdGrp: WB_ProductGroupRow) => aPrdGrp.cif.WB_PRDGRP_ID
                );

                let bActiveOnly = ("bIncludeInactive" in copyOptions) && !copyOptions.bIncludeInactive
                for (
                    let prdGrpIdx = 0;
                    prdGrpIdx < self.WB_TPMEvent.WB_TPM_EventProductGroupRows.length;
                    prdGrpIdx++
                ) {
                    const srcEvtPG = self.WB_TPMEvent.WB_TPM_EventProductGroupRows[prdGrpIdx];
                    if (!srcEvtPG.isActive)
                        continue;


                    if (srcEvtPG.cif.WB_PRDGRP_ID in dctValidPrdGrps) {
                        if (bActiveOnly && srcEvtPG.WB_ProductGroupRow.cif.STATUS_CODE != "Active") {
                            deletedPrdGrps.push(srcEvtPG.WB_ProductGroupRow);
                            continue;
                        }

                        const copiedEvtPGs: WB_TPM_EventProductGroupRow[] = await newTPMEventBO.addTPMEventProductGroup(srcEvtPG.cif.WB_PRDGRP_ID, { bWithoutRefresh: true })

                        if (copiedEvtPGs.length) {
                            let tgtEvtPG = copiedEvtPGs[0].cif
                            tgtEvtPG.CNS_LIFT_PCNT = srcEvtPG.cif.CNS_LIFT_PCNT;
                            tgtEvtPG.CNS_LIFT_PCNT_OVRD = srcEvtPG.cif.CNS_LIFT_PCNT_OVRD;
                            tgtEvtPG.CNS_FORWARD_BUY_PCNT = srcEvtPG.cif.CNS_FORWARD_BUY_PCNT;
                            tgtEvtPG.PROMOTED_PRICE = srcEvtPG.cif.PROMOTED_PRICE;
                            tgtEvtPG.EDLP_PRICE = srcEvtPG.cif.EDLP_PRICE;
                            tgtEvtPG.DISCOUNT_AMT = srcEvtPG.cif.DISCOUNT_AMT;
                            tgtEvtPG.DISCOUNT_PCNT = srcEvtPG.cif.DISCOUNT_PCNT;
                            tgtEvtPG.COVERAGE_FACTOR = srcEvtPG.cif.COVERAGE_FACTOR;
                            tgtEvtPG.CNS_LIFT_PCNT = srcEvtPG.cif.CNS_LIFT_PCNT;
                            tgtEvtPG.CNS_LIFT_PCNT_OVRD= srcEvtPG.cif.CNS_LIFT_PCNT_OVRD;
                            tgtEvtPG.DISPLAY_COMP_IND = srcEvtPG.cif.DISPLAY_COMP_IND;
                        }

                    } else {
                        deletedPrdGrps.push(srcEvtPG.WB_ProductGroupRow);
                    }
                }

                //<editor-fold desc="As a part of PM-5437">
                const srcPlanMDispVolHandling =
                    self.WB_TPMEvent.WB_PlanRow.WB_PlanTypeRow.cif.DISPLAY_HANDLING_METHOD_ID;
                const targetPlanMDispVolHandling =
                    tgtEvt.WB_PlanRow.WB_PlanTypeRow.cif.DISPLAY_HANDLING_METHOD_ID;
                //</editor-fold>

                // Copy only the active shipper/display products; let others get added by the sync function
                let arrShipperProds: WB_TPM_EventProductRow[] = _.filter(
                    self.WB_TPMEvent.WB_TPM_EventProductRows,
                    (aTPMEvtPrdRow: WB_TPM_EventProductRow) =>
                        aTPMEvtPrdRow.isActive &&
                        aTPMEvtPrdRow.cif.ROW_TYPE == "Display"
                );

                if (bActiveOnly)
                    arrShipperProds = _.filter(arrShipperProds, aTPMEvtPrdRow => aTPMEvtPrdRow.WB_ProductRow.cif.STATUS_CODE == "Active")

                if (srcPlanMDispVolHandling == targetPlanMDispVolHandling) {
                    for (let prdIdx = 0; prdIdx < arrShipperProds.length; prdIdx++) {
                        const prd = arrShipperProds[prdIdx];
                        const aTPMEventProduct: WB_TPM_EventProductRow[] = <WB_TPM_EventProductRow[]>await newTPMEventBO.addTPMEventProduct(prd.cif.WB_PROD_ID, {
                            RowType: prd.cif.ROW_TYPE,
                            bWithoutRefresh: true
                        })

                        if (aTPMEventProduct.length > 0)
                            aTPMEventProduct[0].cif.PARENT_ROW_ID = prd.cif.PARENT_ROW_ID;

                    }

                    // Create Metric Records
                    await newTPMEventBO._ProductMetrics_synchronize()
                } else {
                    _.forEach(
                        tgtEvt.WB_TPM_EventProductGroupRows,
                        (aPrdGrpRow: WB_TPM_EventProductGroupRow) => {
                            aPrdGrpRow.cif.DISPLAY_COMP_IND = "0";
                        }
                    );
                }

                const copiedSpends: ITPMEventSpend[] = [];
                for (let spendIdx = 0; spendIdx < self.WB_TPMEvent.WB_TPM_EventSpendRows.length; spendIdx++) {

                    const srcSpend = self.WB_TPMEvent.WB_TPM_EventSpendRows[spendIdx];
                    if (!srcSpend.isActive)
                        continue;

                    const planPeriodStartDt = newTPMEventBO.WB_TPMEvent.WB_PlanRow.WB_PeriodRow.PeriodStartDt;
                    const evtTypeSpendTypeRows: WB_EventSpendTypeRelationshipRow[] =
                        self.WB_TPMEvent.WB_EventTypeRow.WB_EventSpendTypeRows;

                    const evtTypeSpendTypeRow: WB_EventSpendTypeRelationshipRow = _.first(
                        _.filter(evtTypeSpendTypeRows, (aRow: WB_EventSpendTypeRelationshipRow) => {
                            return aRow.cif.WB_EVTSTYPE_ID == srcSpend.cif.WB_EVTSTYPE_ID;
                        })
                    );
                    let bValidSpend: boolean = false;

                    if (!_.isUndefined(evtTypeSpendTypeRow)) {
                        const evtTypeSpendTypeEffectiveEndDt: Date = evtTypeSpendTypeRow.EffectiveEndDt;
                        if (DateUtils.isGreaterThanEqual(evtTypeSpendTypeEffectiveEndDt, planPeriodStartDt))
                            bValidSpend = true;
                    }

                    if (bValidSpend) {
                        const aTPMEventSpend: TPMEventSpend = <TPMEventSpend>await newTPMEventBO.addTPMEventSpend(srcSpend.cif.WB_EVTSTYPE_ID, { SkipCalculatorRefresh: true })

                        let tgtSpend = aTPMEventSpend.TPMEventSpendRow.cif
                        tgtSpend.ACTIVE_IND            = srcSpend.cif.ACTIVE_IND;
                        tgtSpend.EVENT_SPEND_NAME      = srcSpend.cif.EVENT_SPEND_NAME;
                        tgtSpend.EVENT_SPEND_COMMENTS  = srcSpend.cif.EVENT_SPEND_COMMENTS;
                        tgtSpend.RATE_AMT              = srcSpend.cif.RATE_AMT;
                        tgtSpend.RATE_UOM              = srcSpend.cif.RATE_UOM;
                        tgtSpend.REDEMPTION_RATE_PCNT  = srcSpend.cif.REDEMPTION_RATE_PCNT;
                        tgtSpend.RATE_BASIS_ID         = srcSpend.cif.RATE_BASIS_ID;
                        tgtSpend.PAYMENT_METHOD        = srcSpend.cif.PAYMENT_METHOD;
                        tgtSpend.INSTORE_START_DT      = srcSpend.cif.INSTORE_START_DT;
                        tgtSpend.INSTORE_END_DT        = srcSpend.cif.INSTORE_END_DT;
                        tgtSpend.SHIPMENT_START_DT     = srcSpend.cif.SHIPMENT_START_DT;
                        tgtSpend.SHIPMENT_END_DT       = srcSpend.cif.SHIPMENT_END_DT;
                        tgtSpend.ORDER_START_DT        = srcSpend.cif.ORDER_START_DT;
                        tgtSpend.ORDER_END_DT          = srcSpend.cif.ORDER_END_DT;
                        tgtSpend.DISTRIBUTION_START_DT = srcSpend.cif.DISTRIBUTION_START_DT;
                        tgtSpend.DISTRIBUTION_END_DT   = srcSpend.cif.DISTRIBUTION_END_DT;
                        tgtSpend.RATE_PRDVOLBASIS      = srcSpend.cif.RATE_PRDVOLBASIS;
                        tgtSpend.WB_CUST_ID_INDIRECT   = srcSpend.cif.WB_CUST_ID_INDIRECT;
                        aTPMEventSpend.TPMEventSpendRow.WB_TPM_EventSpendTypeRow = srcSpend.WB_TPM_EventSpendTypeRow;

                        //resetting the dates according to the Plan being selected
                        tgtSpend.INSTORE_START_DT = DateUtils.convertToSAPBW(
                            DateUtils.addDays(aTPMEventSpend.TPMEventSpendRow.InStoreStartDt, offset)
                        );
                        tgtSpend.INSTORE_END_DT = DateUtils.convertToSAPBW(
                            DateUtils.addDays(aTPMEventSpend.TPMEventSpendRow.InStoreEndDt, offset)
                        );
                        tgtSpend.SHIPMENT_START_DT =
                            DateUtils.convertToSAPBW(
                                DateUtils.addDays(
                                    aTPMEventSpend.TPMEventSpendRow.ShipmentStartDt,
                                    offset
                                )
                            );
                        tgtSpend.SHIPMENT_END_DT = DateUtils.convertToSAPBW(
                            DateUtils.addDays(aTPMEventSpend.TPMEventSpendRow.ShipmentEndDt, offset)
                        );
                        tgtSpend.ORDER_START_DT = DateUtils.convertToSAPBW(
                            DateUtils.addDays(aTPMEventSpend.TPMEventSpendRow.OrderStartDt, offset)
                        );
                        tgtSpend.ORDER_END_DT = DateUtils.convertToSAPBW(
                            DateUtils.addDays(aTPMEventSpend.TPMEventSpendRow.OrderEndDt, offset)
                        );
                        tgtSpend.DISTRIBUTION_START_DT =
                            DateUtils.convertToSAPBW(
                                DateUtils.addDays(
                                    aTPMEventSpend.TPMEventSpendRow.DistributionStartDt,
                                    offset
                                )
                            );
                        tgtSpend.DISTRIBUTION_END_DT =
                            DateUtils.convertToSAPBW(
                                DateUtils.addDays(
                                    aTPMEventSpend.TPMEventSpendRow.DistributionEndDt,
                                    offset
                                )
                            );

                        // Copy the Product Group Rates...(At this point, the refresh has been called.. and should have the same PGs..
                        for (const aSrcRow of
                            _.filter(srcSpend.WB_TPM_EventSpendPrdGrpRows, (aRow) => aRow.isActive)) {
                            const arrTar = await aTPMEventSpend.addTPMEventSpendProductGroup(aSrcRow.cif.WB_PRDGRP_ID, { bInclude: true })
                            if (!_.isEmpty(arrTar)) {
                                const aTarRow = _.first(arrTar)
                                aTarRow.cif.RATE_AMT = aSrcRow.cif.RATE_AMT || 0;
                                aTarRow.cif.INCLUDE_IND = aSrcRow.cif.INCLUDE_IND || "0";
                                aTarRow.cif.SHIP_DISPLAY_QTY = aSrcRow.cif.SHIP_DISPLAY_QTY || 0;
                                aTarRow.cif.SHIP_BUOM_QTY = aSrcRow.cif.SHIP_BUOM_QTY || 0;
                            }

                        }
                        for (const aSrcPrdRow of
                            _.filter(srcSpend.WB_TPM_EventSpendPrdRows, (aRow) => aRow.isActive)) {
                            const arrTar = await aTPMEventSpend.addTPMEventSpendProduct(aSrcPrdRow.cif.WB_PROD_ID, {
                                bInclude: true,
                                RowType: aSrcPrdRow.cif.ROW_TYPE
                            })
                            if (!_.isEmpty(arrTar)) {
                                const aTarRow = _.first(arrTar)
                                aTarRow.cif.SHIP_DISPLAY_QTY =
                                    aSrcPrdRow.cif.SHIP_DISPLAY_QTY || 0;
                                aTarRow.cif.SHIP_BUOM_QTY =
                                    aSrcPrdRow.cif.SHIP_BUOM_QTY || 0;
                                aTarRow.cif.RATE_AMT =
                                    aSrcPrdRow.cif.RATE_AMT || 0;
                                aTarRow.cif.INCLUDE_IND =
                                    aSrcPrdRow.cif.INCLUDE_IND || "0";
                            }
                        }
                        copiedSpends.push(aTPMEventSpend);
                    }
                }

                //copying product metrics ship display quantities
                let srcMtrcPeriods = _.sortBy(await self.getProductMetricsPeriods(), p => p.PeriodStartDt)
                let tgtMtrcPeriods = _.sortBy(await newTPMEventBO.getProductMetricsPeriods(), p => p.PeriodStartDt)
                let dctPeriodIdxMap: { [tgtWbPeriodId: number]: number } = {}
                _.forEach(srcMtrcPeriods, (srcPeriod, idx) => {
                    let tgtPeriod = tgtMtrcPeriods[idx];
                    if (_.isEmpty(tgtPeriod))
                        return
                    dctPeriodIdxMap[tgtPeriod.cif.WB_PERIOD_ID] = srcPeriod.cif.WB_PERIOD_ID;
                })
                let dctSrcRows: { [wbProdId: number]: { [wbPeriodId: number]: WB_TPM_EventProductMetricsRow } } = {}
                _.forEach(self.WB_TPMEvent.WB_TPM_EventProductMetricsRows, (srcRow) => {
                    if (!srcRow.isActive)
                        return
                    _.set(dctSrcRows, [srcRow.cif.WB_PROD_ID, srcRow.cif.WB_PERIOD_ID], srcRow)
                })

                for (let newRow of tgtEvt.WB_TPM_EventProductMetricsRows) {
                    let wbPeriodId = newRow.cif.WB_PERIOD_ID;
                    if (wbPeriodId in dctPeriodIdxMap)
                        wbPeriodId = dctPeriodIdxMap[wbPeriodId];

                    const wbProdId = newRow.cif.WB_PROD_ID;
                    const srcRow = _.get(dctSrcRows, [wbProdId, wbPeriodId]);

                    if (!_.isEmpty(srcRow)) {
                        newRow.cif.SHIP_DISPLAY_QTY = +srcRow.cif.SHIP_DISPLAY_QTY;
                        newRow.cif.SOP_BB_COMP_RATE = 0;
                        newRow.cif.SOP_BB_OS_RATE = 0;
                        newRow.cif.SOP_BB_RATE = 0;
                        newRow.cif.SOP_OI_COMP_RATE = 0;
                        newRow.cif.SOP_OI_OS_RATE = 0;
                        newRow.cif.SOP_OI_RATE = 0;
                    }
                }
                await newTPMEventBO.EventStandardCalculator.Refresh({
                    bIncludeVolume: true,
                    bIncludePricing: true,
                    bRunRowCalc: true,
                    bIncludeSpendProductGroupsSync: true,
                    bIncludeSpendProductsSync: true,
                    TPMEventSpends: copiedSpends
                });

            } else {
                console.log("TPM Event BO creation failed");
            }

            //raise a info message for the ignored product groups
            if (deletedPrdGrps.length > 0) {
                let delPrdGrpStr: string = "";
                _.forEach(deletedPrdGrps, (aPrdGrp: WB_ProductGroupRow) => {
                    delPrdGrpStr =
                        delPrdGrpStr + ` ${aPrdGrp.cif.PRODUCT_GROUP_ID} - ${aPrdGrp.cif.PRODUCT_GROUP_NAME}; `;
                });
                newTPMEventBO.ValidateMessageProvider.addMessage({
                    code: "IgnoredProductGroups",
                    type: MessageType.Information,
                    title:
                        "The following PPGs were removed from the event; They are not valid in this planning year: " +
                        delPrdGrpStr,
                    description: "",
                    subtitle: "",
                    count: 0
                });
            }
            const auditService = await TPMEventBOAudit.CopyTPMEventAuditBO(newTPMEventBO, self, deletedPrdGrps);
            await auditService.Save(false);

            return (newTPMEventBO);

        } catch (err) {
            console.log("TPMEventBO creation failed:");
            console.log(err);

        }

    };

    Delete(): Promise<IBusinessObject> {
        const self = this;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start(
            "Deleting " + self.WB_TPMEvent.cif.EVENT_NAME + "(" + self.WB_TPMEvent.cif.EVENT_ID + ")"
        );
        return new Promise<IBusinessObject>((resolve, reject) => {
            TPMEventBOValidations.ValidateBeforeDelete(self)
                .then(() => {
                    if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    self.drWB_TPMEvent.markDeleted();
                    _.forEach(self.drWB_TPMEvent.WB_TPM_EventProductGroupRows, (a) => a.markDeleted());
                    _.forEach(self.drWB_TPMEvent.WB_TPM_EventProductRows, (a) => a.markDeleted());
                    _.forEach(self.drWB_TPMEvent.WB_TPM_EventTagRows, (a) => a.markDeleted());
                    _.forEach(self.drWB_TPMEvent.WB_TPM_EventSpendRows, (a) => {
                        a.markDeleted();
                        _.forEach(a.WB_TPM_EventSpendPrdGrpRows, (pgr) => pgr.markDeleted());
                        _.forEach(a.WB_TPM_EventSpendPrdRows, (prdr) => prdr.markDeleted());
                    });
                    self.DeleteProgressProvider.finish();
                    return self.SaveUsing(false, false, false);
                })
                .then(() => {
                    if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                        return;
                    }
                    self._bIsDeleted = true;
                })
                .then(() => {
                    self.SaveProgressProvider.finish();
                    resolve(self);
                });
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        const opts = options || {};
        opts.dctExcludeFields = opts.dctExcludeFields || {};
        opts.dctExcludeFields[esWB_TPM_Event_Product] = ["OES_SENT_TO_IND"];
        opts.dctExcludeFields[esWB_TPM_Event_Product_Group] = ["OES_SENT_TO_IND"];
        opts.bIgnoreStandardFields = true;
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {};
        opts.dctIgnoreChanges[esWB_TPM_Event_Product_Metrics] = { bDeletes: true, bNew: true };

        // Set any BO Specific change settings
        return DefaultChanges(this, this.drWB_TPMEvent, opts);
    }

    //</editor-fold>

    //<editor-fold desc="IHaveEventCalculator operations">

    private _EventCalculator: ITPMEventCalculator;

    private IHaveEventCalculator_init() {
        this._EventCalculator = new TPMEventCalculator();
    }

    private IHaveEventCalculator_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self._EventCalculator.Register(self);
            resolve();
        });
    }

    private IHaveEventCalculator_BeforeReload(): void {
        // Do nothing
    }

    get EventCalculator(): ITPMEventCalculator {
        return this._EventCalculator;
    }

    //</editor-fold>

    //<editor-fold desc="IHaveEventStandardCalculator operations">

    private _EventStandardCalculator: ITPMEventStandardCalculator;

    private IHaveEventStandardCalculator_init() {
        this._EventStandardCalculator = new TPMEventStandardCalculator();
    }

    private IHaveEventStandardCalculator_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self._EventStandardCalculator.Register(self);
            resolve();
        });
    }

    private IHaveEventStandardCalculator_BeforeReload(): void {
        // Do nothing
    }

    get EventStandardCalculator(): ITPMEventStandardCalculator {
        return this._EventStandardCalculator;
    }

    //</editor-fold>

    //<editor-fold desc = "ITPMEvent operations">

    _TPMEventPropertyChanged: BehaviorSubject<ITPMEventChangedEvent>;

    ITPMEvent_init() {
        this._TPMEventPropertyChanged = new BehaviorSubject<ITPMEventChangedEvent>(undefined);
    }

    private ITPMEvent_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self.WB_TPMEvent.setupOnChangeEvents([], self.ITPMEvent_onRecordChange.bind(self), self);
            resolve();
        });
    }

    private ITPMEvent_BeforeReload(): void {
        // Do nothing
    }

    private ITPMEvent_onRecordChange(
        record: WB_TPM_EventRow,
        propertyName: string,
        propertyValue: any,
        options: TPMEventBO
    ) {
        this.TPMEventPropertyChanged.next({
            TPMEventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        });
    }

    get TPMEventPropertyChanged(): BehaviorSubject<ITPMEventChangedEvent> {
        return this._TPMEventPropertyChanged;
    }

    //</editor-fold>

    //<editor-fold desc = "ITPMEventProductGroups operations">

    _TPMEventProductGroupCollectionChanged: BehaviorSubject<ITPMEventProductGroups>;
    _TPMEventProductGroupPropertyChanged: BehaviorSubject<ITPMEventProductGroupChangedEvent>;

    ITPMEventProductGroups_init(): void {
        this._TPMEventProductGroupCollectionChanged = new BehaviorSubject<ITPMEventProductGroups>(undefined);
        this._TPMEventProductGroupPropertyChanged = new BehaviorSubject<ITPMEventProductGroupChangedEvent>(undefined);
    }

    private ITPMEventProductGroups_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            _.forEach(self.WB_TPMEvent.WB_TPM_EventProductGroupRows, (aRow) => {
                aRow.setupOnChangeEvents([], self.ITPMEventProductGroup_onRecordChange.bind(self), self);
            });
            resolve();
        });
    }

    private ITPMEventProductGroups_BeforeReload(): void {
        // Do nothing
    }

    private ITPMEventProductGroup_onRecordChange(
        record: WB_TPM_EventProductGroupRow,
        propertyName: string,
        propertyValue: any,
        options: TPMEventBO
    ) {
        this.TPMEventProductGroupPropertyChanged.next({
            TPMEventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        });
    }

    get TPMEventProductGroupCollectionChanged(): BehaviorSubject<ITPMEventProductGroups> {
        return this._TPMEventProductGroupCollectionChanged;
    }

    get TPMEventProductGroupPropertyChanged(): BehaviorSubject<ITPMEventProductGroupChangedEvent> {
        return this._TPMEventProductGroupPropertyChanged;
    }

    addTPMEventProductGroup(
        wb_prdgrp_id: number | number[],
        options?: ITPMEventProductGroupsAddOptions
    ): Promise<WB_TPM_EventProductGroupRow[]> {
        const self = this;
        const opts: ITPMEventProductGroupsAddOptions = options || {};

        return new Promise<WB_TPM_EventProductGroupRow[]>((resolve, error) => {
            let pgRows: WB_ProductGroupRow[] = [];
            const newRows: WB_TPM_EventProductGroupRow[] = [];
            let arrWB_PrdGrp_ID: number[] = [];
            let openStockProdGrp: string,
                displayCompPrdGrp: string = "0";
            if (_.isArray(wb_prdgrp_id)) {
                arrWB_PrdGrp_ID = wb_prdgrp_id;
            } else {
                arrWB_PrdGrp_ID = [wb_prdgrp_id];
            }

            openStockProdGrp = opts.bOpenStockPrdGrp ? "1" : "0";
            displayCompPrdGrp = opts.bDisplayCompPrdGrp ? "1" : "0";

            self.dbContext
                .findUsingCache(esWB_Product_Group, arrWB_PrdGrp_ID)
                .then((aPGRows: WB_ProductGroupRow[]) => {
                    //
                    if (_.isEmpty(aPGRows)) {
                        resolve([]);
                        return;
                    }
                    pgRows = aPGRows;

                    async function createRows() {
                        for (let idx = 0; idx < pgRows.length; idx++) {
                            const pgRow = pgRows[idx];
                            const aNewRow = <WB_TPM_EventProductGroupRow>(
                                await self.dbContext.createRecordWithKey(esWB_TPM_Event_Product_Group)
                            );
                            aNewRow.setDefaults();
                            aNewRow.cif.WB_TEVT_ID = self.WB_TPMEvent.cif.WB_TEVT_ID;
                            aNewRow.cif.WB_PRDGRP_ID = pgRow.cif.WB_PRDGRP_ID;
                            aNewRow.cif.ROW_TYPE = "ProductGroup";

                            aNewRow.cif.OPENSTOCK_IND = openStockProdGrp;
                            aNewRow.cif.DISPLAY_COMP_IND = displayCompPrdGrp;

                            self.dbContext.add(esWB_TPM_Event_Product_Group, aNewRow);
                            newRows.push(aNewRow);
                        }
                        return;
                    }

                    return createRows();
                })
                .then(() => {
                    if (_.isEmpty(newRows)) {
                        resolve([]);
                        return;
                    }

                    _.forEach(newRows, (aRow) => {
                        aRow.setupOnChangeEvents([], self.ITPMEventProductGroup_onRecordChange.bind(self), self);
                    });

                    if (opts.bWithoutRefresh) return;
                    // Call Standard Calculator to get Pricing, Base Volume, etc.
                    return self.EventStandardCalculator.BaseMetrics_update({
                        WB_TPM_EventProductGroupRows: newRows,
                        bIncludeVolume: true,
                        bIncludePricing: true,
                        bRunRowCalc: true
                    });
                })
                .then((ignore: any) => {
                    if (opts.bWithoutRefresh) return;
                    // Call Standard Calculator to push down the Products.
                    return self.EventStandardCalculator.Products_synchronize({
                        WB_TPM_EventProductGroupRows: newRows
                    });
                })
                .then((ignore: any) => {
                    if (opts.bWithoutRefresh) return;
                    self.TPMEventProductGroupCollectionChanged.next(self);
                })
                .then((ignore: any) => {
                    resolve(newRows);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    removeTPMEventProductGroup(
        aWB_TEVTPG_ID: number | number[],
        options?: ITPMEventProductGroupsRemoveOptions
    ): Promise<void> {
        const self = this;
        const opts: ITPMEventProductGroupsRemoveOptions = options || {};

        return new Promise<void>((resolve, error) => {
            let arraWB_TEVTPG_IDs: number[] = [];

            if (_.isArray(aWB_TEVTPG_ID)) {
                arraWB_TEVTPG_IDs = aWB_TEVTPG_ID;
            } else {
                arraWB_TEVTPG_IDs = [aWB_TEVTPG_ID];
            }

            // Check canRemove ?

            const arrPGRows = _.filter(
                self.WB_TPMEvent.WB_TPM_EventProductGroupRows,
                (aRow: WB_TPM_EventProductGroupRow) =>
                    aRow.isActive &&
                    aRow.cif.OES_SENT_TO_IND != "1" &&
                    _.includes(arraWB_TEVTPG_IDs, aRow.cif.WB_TEVTPG_ID)
            );

            _.forEach(arrPGRows, (aRow: WB_TPM_EventProductGroupRow) => {
                aRow.markDeleted();
            });

            if (opts.bWithoutRefresh) {
                resolve();
                return;
            }

            // Refresh the Products..
            self.EventStandardCalculator.Products_synchronize({})
                .then(() => {
                    self.TPMEventProductGroupCollectionChanged.next(self);
                    resolve();
                })
                .catch((err) => {
                    error("removeTPMEventProductGroup: failed Product Synchronization, " + err);
                });
        });
    }

    canRemoveTPMEventProductGroup(aWB_TEVTPG_ID: number): boolean {
        const self = this;

        const aPGRow = _.first(
            _.filter(
                self.WB_TPMEvent.WB_TPM_EventProductGroupRows,
                (aRow: WB_TPM_EventProductGroupRow) => aRow.isActive && aRow.cif.WB_TEVTPG_ID == aWB_TEVTPG_ID
            )
        );

        if (!aPGRow) {
            return false;
        }
        if (aPGRow.cif.OES_SENT_TO_IND == "1") {
            return false;
        }

        const iWBPGId = aPGRow.cif.WB_PRDGRP_ID;
        // Check the Event Spend records
        let bCanRemovePG = true;
        _.forEach(
            _.filter(this.WB_TPMEvent.WB_TPM_EventSpendRows, (aRow) => aRow.isActive),
            (aSpRow) => {
                if (!bCanRemovePG) {
                    return false;
                }
                const rows = _.filter(aSpRow.WB_TPM_EventSpendPrdGrpRows, (aRow) => {
                    return aRow.isActive && aRow.cif.WB_PRDGRP_ID == iWBPGId && aRow.cif.ACTUAL_SPEND > 0;
                });
                if (rows.length > 0) {
                    bCanRemovePG = false;
                    return false;
                }
            }
        );

        return bCanRemovePG;
    }

    //</editor-fold>

    //<editor-fold desc = "ITPMEventProducts operations">

    private _TPMEventProductCollectionChanged: BehaviorSubject<ITPMEventProducts>;
    private _TPMEventProductPropertyChanged: BehaviorSubject<ITPMEventProductChangedEvent>;

    ITPMEventProduct_init(): void {
        this._TPMEventProductCollectionChanged = new BehaviorSubject<ITPMEventProducts>(this);
        this._TPMEventProductPropertyChanged = new BehaviorSubject<ITPMEventProductChangedEvent>(undefined);
    }

    private ITPMEventProducts_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            _.forEach(self.WB_TPMEvent.WB_TPM_EventProductRows, (aRow) => {
                aRow.setupOnChangeEvents([], self.ITPMEventProduct_onRecordChange.bind(self), self);
            });
            resolve();
        });
    }

    private ITPMEventProducts_BeforeReload(): void {
        // Do nothing
    }

    private ITPMEventProduct_onRecordChange(
        record: WB_TPM_EventProductRow,
        propertyName: string,
        propertyValue: any,
        options: TPMEventBO
    ) {
        this.TPMEventProductPropertyChanged.next({
            TPMEventBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        });
    }

    get TPMEventProductCollectionChanged(): BehaviorSubject<ITPMEventProducts> {
        return this._TPMEventProductCollectionChanged;
    }

    get TPMEventProductPropertyChanged(): BehaviorSubject<ITPMEventProductChangedEvent> {
        return this._TPMEventProductPropertyChanged;
    }

    addTPMEventProduct(
        wb_prod_id: number | number[],
        options: ITPMEventProductsAddOptions
    ): Promise<WB_TPM_EventProductRow[]> {
        const self = this;
        const opts: ITPMEventProductsAddOptions = {};
        _.defaults(opts, options, ITPMEventProductsAddOptionsDefaults);

        return new Promise<WB_TPM_EventProductRow[]>((resolve, error) => {
            let prdRows: WB_FinishedProductRow[] = [];
            const newRows: WB_TPM_EventProductRow[] = [];
            let arrWB_Prod_ID: number[] = [];
            if (_.isArray(wb_prod_id)) {
                arrWB_Prod_ID = wb_prod_id;
            } else {
                arrWB_Prod_ID = [wb_prod_id];
            }

            self.dbContext
                .findUsingCache(esWB_Finished_Product, arrWB_Prod_ID)
                .then((aPrdRows: WB_FinishedProductRow[]) => {
                    //
                    if (_.isEmpty(aPrdRows)) {
                        resolve([]);
                        return;
                    }
                    prdRows = aPrdRows;

                    async function createRows() {
                        for (let idx = 0; idx < prdRows.length; idx++) {
                            const prdRow = prdRows[idx];
                            const aNewRow = <WB_TPM_EventProductRow>(
                                await self.dbContext.createRecordWithKey(esWB_TPM_Event_Product)
                            );
                            aNewRow.setDefaults();
                            aNewRow.cif.WB_TEVT_ID = self.WB_TPMEvent.cif.WB_TEVT_ID;
                            aNewRow.cif.WB_PROD_ID = prdRow.cif.WB_PROD_ID;
                            aNewRow.WB_ProductRow = prdRow;
                            // RowTypes defined in EvtProductRowType
                            if (!_.isEmpty(opts.RowType)) {
                                aNewRow.cif.ROW_TYPE = opts.RowType;
                            } else {
                                if (prdRow.cif.PRODUCT_SET_ID == "UPC") {
                                    aNewRow.cif.ROW_TYPE = "Consumer";
                                } else {
                                    // TODO: Add Display Case
                                    aNewRow.cif.ROW_TYPE = "Finished";
                                }
                            }
                            aNewRow.cif.PARENT_ROW_ID = opts.ParentRowId || 0;
                            self.dbContext.add(esWB_TPM_Event_Product, aNewRow);
                            newRows.push(aNewRow);
                        }
                        return;
                    }

                    return createRows();
                })
                .then(() => {
                    if (_.isEmpty(newRows)) {
                        resolve([]);
                        return;
                    }

                    _.forEach(newRows, (aRow) => {
                        aRow.setupOnChangeEvents([], self.ITPMEventProduct_onRecordChange.bind(self), self);
                    });

                    // TODO : Call Standard Calculator if needed
                    if (opts.bWithoutRefresh) {
                        resolve(newRows);
                        return;
                    }
                    return self.EventStandardCalculator.Products_synchronize({});
                })
                .then((ignore: any) => {
                    if (opts.bWithoutRefresh)
                        return
                    self.TPMEventProductCollectionChanged.next(self);
                    //resolve(newRows)
                })
                .then((ignore: any) => {
                    if (opts.bWithoutRefresh)
                        return
                    return self.ProductMetrics_synchronize();
                })
                .then((ignore: any) => {
                    resolve(newRows);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    canRemoveTPMEventProductRow(aWB_TEVTPRD_ID: number): boolean {
        const self = this;

        const arrPrdRows: WB_TPM_EventProductRow[] = _.filter(
            self.WB_TPMEvent.WB_TPM_EventProductRows,
            (aRow: WB_TPM_EventProductRow) => aRow.cif.WB_TEVTPRD_ID == aWB_TEVTPRD_ID
        );

        //aRow.isActive && (aRow.cif.OES_SENT_TO_IND != '1') &&
        const aRow = arrPrdRows[0];
        if (aRow.isActive && aRow.cif.OES_SENT_TO_IND != "1" && aRow.cif.PARENT_ROW_ID == 0) {
            return true;
        }

        return false;
    }

    removeTPMEventProductRow(
        aWB_TEVTPRD_ID: number | number[],
        options?: ITPMEventProductsRemoveOptions
    ): Promise<void> {
        const self = this;
        const opts = options || {};

        return new Promise<void>((resolve, error) => {
            let arrWB_TEVTPRD_ID: number[] = [];

            if (_.isArray(aWB_TEVTPRD_ID)) {
                arrWB_TEVTPRD_ID = aWB_TEVTPRD_ID;
            } else {
                arrWB_TEVTPRD_ID = [aWB_TEVTPRD_ID];
            }

            const arrPrdRows = _.filter(
                self.WB_TPMEvent.WB_TPM_EventProductRows,
                (aRow: WB_TPM_EventProductRow) =>
                    aRow.isActive &&
                    aRow.cif.OES_SENT_TO_IND != "1" &&
                    _.includes(arrWB_TEVTPRD_ID, aRow.cif.WB_TEVTPRD_ID)
            );

            _.forEach(arrPrdRows, (aRow: WB_TPM_EventProductRow) => {
                aRow.markDeleted();
            });

            self.TPMEventProductCollectionChanged.next(self);
            if (opts.bWithoutRefresh) {
                resolve();
                return;
            }
            self.EventStandardCalculator.Products_synchronize({})
                .then((ignore: any) => {
                    return self.ProductMetrics_synchronize();
                })
                .then(() => {
                    resolve();
                });
        });
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveProductGroup operations">

    _bIHaveProductGroupsLoaded: boolean;
    _OnIHaveProductGroupsLoaded: Promise<IHaveProductGroups>;
    _ProductGroupsAll: WB_ProductGroupRow[];
    _ProductGroupsChanged: BehaviorSubject<IHaveProductGroups>;
    _hsn: IHierarchyStructureNavigator
    _hs: IHierarchyStructure


    private IHaveProductGroups_init() {
        this._ProductGroupsChanged = new BehaviorSubject<IHaveProductGroups>(this);
        this._bIHaveProductGroupsLoaded = false;
        this._OnIHaveProductGroupsLoaded = undefined;
        this._ProductGroupsAll = [];
        this._hs = undefined;
        this._hsn = undefined;
    }

    private IHaveProductGroup_BeforeReload(): void {
        this._bIHaveProductGroupsLoaded = false;
        this._OnIHaveProductGroupsLoaded = undefined;
    }

    get ProductGroupsChanged(): BehaviorSubject<IHaveProductGroups> {
        return this._ProductGroupsChanged;
    }

    get bIHaveProductGroupsLoaded(): boolean {
        return this._bIHaveProductGroupsLoaded;
    }

    get ProductHierarchyStructure(): IHierarchyStructure {
        return this._hs
    }


    get ProductHierarchyStructureNavigator(): IHierarchyStructureNavigator {
        return this._hsn
    }


    async OnProductHierarchyStructureLoaded(): Promise<void> {
        const self = this;

        if (self._hs && self._hs.bLoaded) return
        let arrHierarchy: WB_HierarchyRow[] = await self.dbContext.findAll(esWB_Hierarchy, {
            where: {
                TARGET_WB_ID: self.WB_TPMEvent.WB_PlanRow.WB_PlanTypeRow.cif.WB_PRDH_ID,
                DELETED_IND: { neq: "1" }
            }
        })

        let hierarchyRow = _.first(arrHierarchy);
        if (!_.isEmpty(hierarchyRow)) {
            self._hs = await HierarchyStructureManager.getHierarchyStructure(
                hierarchyRow.cif.WB_HIERARCHY_ID,
                { dbContext: self.dbContext }
            )
            await self._hs.OnLoadComplete()
        }
    }

    async OnProductHierarchyStructureNavigatorLoaded(): Promise<void> {
        const self = this;

        if (self._hsn && self._hsn.bLoaded) return

        if (_.isEmpty(self._hs) || !self._hs.bLoaded)
            await self.OnProductHierarchyStructureLoaded()

        // A concurrent Reload() can wipe WB_TPMEvent while the above awaits; wait for it
        // to land again before dereferencing, instead of crashing on the undefined row.
        if (!self.bIsLoaded) {
            await self.OnLoadComplete
        }

        self._hsn = HierarchyStructureNavigator.getHierarchyStructureNavigator(self._hs, self.WB_TPMEvent.WB_PlanRow.WB_PeriodRow.PeriodStartDt, self.WB_TPMEvent.WB_PlanRow.WB_PeriodRow.PeriodEndDt)
        await self._hsn.onLoadComplete()
    }

    get OnIHaveProductGroupsLoaded(): Promise<IHaveProductGroups> {
        const self = this;


        if (self.bIHaveProductGroupsLoaded) {
            return ASync.resolve(self);
        }

        if (!_.isEmpty(self._OnIHaveProductGroupsLoaded)) return self._OnIHaveProductGroupsLoaded; // Load already started, wait on same Promise

        const OnLoadPromise = new Promise<IHaveProductGroups>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if (!self.bIsLoaded && _.isEmpty(self.OnLoadComplete)) {
                error("TPM Event isn't Loaded or Loading.. Can't determine Product Groups");
                return;
            }

            let boLoadPromise = undefined;
            if (self.bIsLoaded) {
                boLoadPromise = ASync.resolve(self);
            } else {
                boLoadPromise = self.OnLoadComplete;
            }
            boLoadPromise
                .then((aTPMEventBO) => {
                    if (!aTPMEventBO.bIsLoaded) {
                        error("Waited on TPM Event Load to complete but still isn't Loaded");
                        return;
                    }
                    return self.OnProductHierarchyStructureNavigatorLoaded()
                })
                .then(() => {
                    return self._hs.Nodes.findNodeByWbId(esWB_Product_Group, self.WB_TPMEvent.WB_PlanRow.cif.WB_PRDGRP_ID_PLANLEVEL)
                })
                .then((topNode: INode) => {
                    let nodes = self._hsn.getChildNodesOfLevel(topNode, self.WB_TPMEvent.WB_PlanRow.WB_PlanTypeRow.cif.PRDGRP_LEVEL_ID)
                    self._ProductGroupsAll = _.map(nodes, "prodRow")
                    // Setup Product Group Collection, flag loaded.
                    this._bIHaveProductGroupsLoaded = true
                    this._OnIHaveProductGroupsLoaded = undefined

                    // Setup Product Group Collection, flag loaded.
                    this._bIHaveProductGroupsLoaded = true;
                    this._OnIHaveProductGroupsLoaded = undefined;

                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });
        });

        self._OnIHaveProductGroupsLoaded = OnLoadPromise;
        return OnLoadPromise;
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        return _.map(
            _.filter(this.WB_TPMEvent.WB_TPM_EventProductGroupRows, (aRow) => aRow.isActive),
            (aRow) => aRow.WB_ProductGroupRow
        );
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._ProductGroupsAll;
    }

    get ProductGroupsReadOnly(): boolean {
        // TODO: Check Security Roles..
        return false;
    }

    addProductGroup(ProductGroupId: number): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self.addTPMEventProductGroup(ProductGroupId, {})
                .then(() => {
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    removeProductGroup(ProductGroupId: number): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            //  TODO:  This is wrong.. wrong Ids.. needs to be row Ids.
            self.removeTPMEventProductGroup(ProductGroupId, {})
                .then(() => {
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    hasProductGroup(ProductGroupId: number): boolean {
        const self = this;
        let returnValue = false;
        _.forEach(self.WB_TPMEvent.WB_TPM_EventProductGroupRows, (aRow) => {
            if (aRow.isActive && aRow.cif.WB_PRDGRP_ID == ProductGroupId) {
                returnValue = true;
                return false; // stop iterating
            }
        });

        return returnValue;
    }

    isProductGroupEditable(ProductGroupId: number): boolean {
        //  TODO:  This is wrong.. wrong Ids.. needs to be row Ids.
        return this.canRemoveTPMEventProductGroup(ProductGroupId);
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveTags operations">

    _bIHaveTagsLoaded: boolean;
    _OnIHaveTagsLoaded: Promise<IHaveTags>;
    _TagsChanged: BehaviorSubject<IHaveTags>;
    _TagBag: TagBag;
    _TagUsageId: string;

    private IHaveTagsLoaded_init() {
        this._bIHaveTagsLoaded = false;
        this._OnIHaveTagsLoaded = undefined;
        this._TagsChanged = new BehaviorSubject<IHaveTags>(this);
        this._TagBag = undefined;
        this._TagUsageId = "AllTagUsage";
    }

    private IHaveTags_BeforeReload() {
        this._bIHaveTagsLoaded = false;
        this._OnIHaveTagsLoaded = undefined;
    }

    get bIHaveTagsLoaded() {
        return this._bIHaveTagsLoaded;
    }

    get TagsReadOnly(): boolean {
        if (this._bIsDeleted) {
            return true;
        }
        // Check User Roles ?

        return false;
    }

    get Tags(): WB_TagRow[] {
        const returnValue: WB_TagRow[] = [];

        _.forEach(this.drWB_TPMEvent.WB_TPM_EventTagRows, (aWBEvtTagRow: WB_TPM_EventTagRow) => {
            if (aWBEvtTagRow && aWBEvtTagRow.isActive && aWBEvtTagRow.WB_TagRow) {
                returnValue.push(aWBEvtTagRow.WB_TagRow);
            }
        });

        return returnValue;
    }

    get TagsChanged(): BehaviorSubject<IHaveTags> {
        return this._TagsChanged;
    }

    get AllTags(): WB_TagRow[] {
        if (this._TagBag) {
            return this._TagBag.AllTags;
        } else {
            return [];
        }
    }

    get UsageId(): string {
        return this._TagUsageId;
    }

    get OnIHaveTagsLoaded(): Promise<IHaveTags> {
        const self = this;

        if (self._bIHaveTagsLoaded) {
            return ASync.resolve(self);
        }

        if (!_.isEmpty(self._OnIHaveTagsLoaded)) {
            return self._OnIHaveTagsLoaded;
        }

        self._OnIHaveTagsLoaded = new Promise<IHaveTags>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if (!self.bIsLoaded && _.isEmpty(self.OnLoadComplete)) {
                error("TPM Event isn't Loaded or Loading.. Can't determine Tags");
                return;
            }

            let loadWait: Promise<any> = undefined;

            if (self.bIsLoaded) {
                loadWait = ASync.resolve(self);
            } else {
                loadWait = self.OnLoadComplete;
            }

            loadWait
                .then((aEventBO) => {
                    if (!aEventBO.bIsLoaded) {
                        error("Waited on TPM Event Load to complete but still isn't Loaded");
                        return;
                    }

                    const PlanRow = self.WB_TPMEvent.WB_PlanRow;
                    if (PlanRow && PlanRow.WB_PlanTypeRow && PlanRow.WB_PlanTypeRow.cif.WB_TAG_ID_USAGE > 0) {
                        return self.dbContext.find(esWB_Tag, PlanRow.WB_PlanTypeRow.cif.WB_TAG_ID_USAGE);
                    }
                })
                .then((tagRow: WB_TagRow) => {
                    if (tagRow) {
                        self._TagUsageId = tagRow.cif.TAG_ID;
                    }

                    self._TagBag = new TagBag({ dbContext: self.dbContext, TagUsage: self._TagUsageId });

                    return self._TagBag.OnIHaveTagsLoaded;
                })
                .then(() => {
                    self._bIHaveTagsLoaded = true;
                    self._OnIHaveTagsLoaded = undefined;
                    resolve(self);
                })
                .catch((err) => {
                    self._OnIHaveTagsLoaded = undefined;
                    error(err);
                });
        });

        return self._OnIHaveTagsLoaded;
    }

    addTag(TagId: number): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            let aTagRow: WB_TagRow = undefined;
            self.dbContext
                .find(esWB_Tag, TagId)
                .then((aNewRow: WB_TagRow) => {
                    if (!aNewRow) {
                        error("Unable to find Tag to add to TPM Event. " + TagId);
                        return;
                    }
                    aTagRow = aNewRow;

                    return self.dbContext.createRecordWithKey(esWB_TPM_Event_Tag);
                })
                .then((aWBEvtTag: WB_TPM_EventTagRow) => {
                    //
                    if (!aWBEvtTag) {
                        error("Unable to create TPM Event Tag record add to TPM Event. ");
                        return;
                    }
                    aWBEvtTag.setDefaults();
                    aWBEvtTag.WB_TagRow = aTagRow;
                    aWBEvtTag.cif.WB_TAG_ID = aTagRow.cif.WB_TAG_ID;
                    aWBEvtTag.cif.WB_TEVT_ID = self.drWB_TPMEvent.cif.WB_TEVT_ID;
                    aWBEvtTag.cif.TAG_METHOD = "Manual";
                    aWBEvtTag.WB_TagRow = aTagRow;
                    self.dbContext.add(esWB_TPM_Event_Tag, aWBEvtTag);
                    self.TagsChanged.next(self);
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    removeTag(TagId: number): void {
        const self = this;
        let changed = false;
        _.forEach(self.drWB_TPMEvent.WB_TPM_EventTagRows, (aWBEvtTagRow: WB_TPM_EventTagRow) => {
            if (aWBEvtTagRow && aWBEvtTagRow.isActive && aWBEvtTagRow.WB_TagRow) {
                if (aWBEvtTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    aWBEvtTagRow.markDeleted();
                    changed = true;
                }
            }
        });

        if (changed) {
            self.TagsChanged.next(self);
        }
    }

    hasTag(TagId: number): boolean {
        let found = false;

        _.forEach(this.drWB_TPMEvent.WB_TPM_EventTagRows, (aWBEvtTagRow: WB_TPM_EventTagRow) => {
            if (aWBEvtTagRow && aWBEvtTagRow.isActive && aWBEvtTagRow.WB_TagRow) {
                if (aWBEvtTagRow.WB_TagRow.cif.WB_TAG_ID == TagId) {
                    found = true;
                    return false; // stop iterating
                }
            }
        });

        return found;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveEventSpend operations">

    private _TPMEventSpends: TPMEventSpend[];
    private _TPMEventSpendCollectionChanged: BehaviorSubject<IHaveTPMEventSpend>;

    private IHaveTPMEventSpend_init() {
        this._TPMEventSpends = [];
        this._TPMEventSpendCollectionChanged = new BehaviorSubject<IHaveTPMEventSpend>(this);
    }

    private IHaveTPMEventSpend_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            async function RunIHaveTPMEventSpend_OnLoadCompleteASync() {
                for (let idx = 0; idx < self.WB_TPMEvent.WB_TPM_EventSpendRows.length; idx++) {
                    const aRow = self.WB_TPMEvent.WB_TPM_EventSpendRows[idx];
                    const aNewSpend = new TPMEventSpend(self, aRow);
                    await aNewSpend.OnLoadComplete;
                    self._TPMEventSpends.push(aNewSpend);
                }
            }

            RunIHaveTPMEventSpend_OnLoadCompleteASync()
                .then(() => {
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    private IHaveTPMEventSpend_BeforeReload(): void {
        this._TPMEventSpends = [];
    }

    get TPMEventSpends(): TPMEventSpend[] {
        return _.filter(this._TPMEventSpends, (aRow: TPMEventSpend) => aRow.isActive);
    }

    get TPMEventSpendCollectionChanged(): BehaviorSubject<IHaveTPMEventSpend> {
        return this._TPMEventSpendCollectionChanged;
    }

    addTPMEventSpend(wb_evtstype_id: number, pOpts: ITPMEventSpendAddOptions): Promise<ITPMEventSpend> {
        const self = this;

        const opts: ITPMEventSpendAddOptions = {};
        _.defaults(opts, pOpts, ITPMEventSpendAddOptionsDefaults);

        return new Promise<ITPMEventSpend>((resolve, error) => {
            let aTPMEventSpendType: WB_TPM_EventSpendTypeRow = undefined;
            let anEventSpend: WB_TPM_EventSpendRow = undefined;
            let aTPMEventSpend: TPMEventSpend = undefined;
            self.dbContext
                .find(esWB_Event_Spend_Type, wb_evtstype_id)
                .then((aSpendType: WB_TPM_EventSpendTypeRow) => {
                    aTPMEventSpendType = aSpendType;
                    if (!aSpendType) {
                        error("Unable to find Spend Type to add to TPM Event. " + wb_evtstype_id);
                        return;
                    }

                    return self.dbContext.createRecordWithKey(esWB_TPM_Event_Spend);
                })
                .then((newRecord: WB_TPM_EventSpendRow) => {
                    //
                    if (_.isEmpty(newRecord)) {
                        error("Unable to create TPM Event Spend record to add to TPM Event.");
                        return;
                    }

                    anEventSpend = newRecord;
                    anEventSpend.cif.WB_EVTSTYPE_ID = aTPMEventSpendType.cif.WB_EVTSTYPE_ID;
                    anEventSpend.cif.WB_TEVT_ID = self.WB_TPMEvent.cif.WB_TEVT_ID;
                    anEventSpend.WB_TPM_EventSpendTypeRow = aTPMEventSpendType;
                    anEventSpend.cif.RATE_BASIS_ID = aTPMEventSpendType.cif.RATEBASIS_DEFAULT;
                    anEventSpend.cif.RATE_UOM = aTPMEventSpendType.cif.RATEUOM_DEFAULT;
                    anEventSpend.cif.PAYMENT_METHOD = aTPMEventSpendType.cif.PAYMENTMETHOD_DEFAULT;
                    anEventSpend.cif.RATE_PRDVOLBASIS = aTPMEventSpendType.cif.PRDVOLBASIS_BB_DEFAULT;
                    anEventSpend.cif.REDEMPTION_RATE_PCNT = 1;
                    anEventSpend.cif.WB_FUNDTYPE_ID = aTPMEventSpendType.cif.FUNDTYPE_DEFAULT;
                    anEventSpend.cif.INSTORE_START_DT = self.WB_TPMEvent.cif.INSTORE_START_DT;
                    anEventSpend.cif.INSTORE_END_DT = self.WB_TPMEvent.cif.INSTORE_END_DT;
                    anEventSpend.cif.SHIPMENT_START_DT = self.WB_TPMEvent.cif.SHIPMENT_START_DT;
                    anEventSpend.cif.SHIPMENT_END_DT = self.WB_TPMEvent.cif.SHIPMENT_END_DT;
                    anEventSpend.cif.DISTRIBUTION_START_DT = self.WB_TPMEvent.cif.DISTRIBUTION_START_DT;
                    anEventSpend.cif.DISTRIBUTION_END_DT = self.WB_TPMEvent.cif.DISTRIBUTION_END_DT;
                    anEventSpend.cif.ORDER_START_DT = self.WB_TPMEvent.cif.ORDER_START_DT;
                    anEventSpend.cif.ORDER_END_DT = self.WB_TPMEvent.cif.ORDER_END_DT;
                    anEventSpend.cif.ACTIVE_IND = "1";
                    return WorkflowStatusService.getInitialWorkflowStatusByWorkflowWbID(
                        aTPMEventSpendType.cif.WB_WORKFLOW_ID
                    );
                })
                .then((aWB_Status) => {
                    if (!anEventSpend) {
                        return;
                    }

                    if (aWB_Status) {
                        anEventSpend.cif.WB_STATUS_ID = aWB_Status.cif.WB_STATUS_ID;
                        anEventSpend.cif.WB_STATUS_ID_NEXT = aWB_Status.cif.WB_STATUS_ID;
                    }

                    self.dbContext.add(esWB_TPM_Event_Spend, anEventSpend);
                    aTPMEventSpend = new TPMEventSpend(self, anEventSpend);
                    return aTPMEventSpend.OnLoadComplete;
                })
                .then(() => {
                    if (!aTPMEventSpend) {
                        return;
                    }
                    self._TPMEventSpends.push(aTPMEventSpend);

                    if (opts.SkipCalculatorRefresh) return;

                    return self.EventStandardCalculator.Refresh({ TPMEventSpends: [aTPMEventSpend] });
                })
                .then(() => {
                    self.TPMEventSpendCollectionChanged.next(self);
                    resolve(aTPMEventSpend);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    removeTPMEventSpend(wb_evts_id: number | number[], options: any): Promise<void> {
        const self = this;

        let arrWB_EvtS_ID: number[] = [];
        if (_.isArray(wb_evts_id)) {
            arrWB_EvtS_ID = wb_evts_id;
        } else {
            arrWB_EvtS_ID = [wb_evts_id];
        }

        return new Promise<void>((resolve, error) => {
            const arrSpend = _.filter(
                self._TPMEventSpends,
                (aSpend: TPMEventSpend) => aSpend.isActive && _.includes(arrWB_EvtS_ID, aSpend.WB_EvtS_ID)
            );

            if (arrSpend.length == 0) {
                resolve();
                return;
            }

            _.forEach(arrSpend, (aSpend) => {
                if (aSpend.bCanDelete) {
                    aSpend.markDeleted();
                }
            });
            self.TPMEventSpendCollectionChanged.next(self);
            resolve();
        });
    }

    canRemoveTPMEventSpend(wb_evts_id: number): boolean {
        const self = this;

        const arrSpend = _.filter(
            self._TPMEventSpends,
            (aSpend: TPMEventSpend) => aSpend.isActive && aSpend.WB_EvtS_ID == wb_evts_id
        );

        if (arrSpend.length == 0) {
            return false;
        }

        const aSpend = _.first(arrSpend);
        return aSpend.bCanDelete;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>;
    private _Lock: ILock;

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection();
        this._bIHaveSecurityLoaded = false;
        this._OnIHaveSecurityLoaded = undefined;
        this._Lock = undefined;
    }

    IHaveSecurity_BeforeReload() {
        this._bIHaveSecurityLoaded = false;
        this._OnIHaveSecurityLoaded = undefined;
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded.then(() => {
                resolve();
            }).catch((err) => {
                error(err);
            });
        });
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this;

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this);
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded;
        }

        let aHasRolePolicy: PolicyHasRole;
        let aStdEventPolicy: TPMEventBOStandardPolicy;

        this._OnIHaveSecurityLoaded = (async (): Promise<IHaveSecurity> => {
            let aLock: ILock = undefined;
            try {
                if (!self.CreateOptions.bSkipLock) {
                    // skip the lock for Tactic Refresh
                    if (_.isEmpty(self._Lock)) {
                        const aLockService = new PALockClient();
                        aLock = aLockService.createLock("TPMEvent", this.drWB_TPMEvent.cif.WB_TEVT_ID, {
                            object: {
                                UI_Id: self.drWB_TPMEvent.cif.EVENT_ID,
                                Name: self.drWB_TPMEvent.cif.EVENT_NAME
                            }
                        });
                    } else {
                        aLock = self._Lock;
                    }
                    await aLock.OnLoaded();
                    await aLock.acquire();
                    self._Lock = aLock;
                }

                const aBOis = new PolicyBOis(
                    ["Super_User", "TPM_Event_Editor", "TPM_SVF_Editor"],
                    [],
                    self.WB_TPMEvent.cif.WB_CUST_ID_PLANNING,
                    aLock,
                    self.WB_TPMEvent.WB_PlanRow.IsClosed
                );
                self.PolicyCollection.addPolicy("BOis", aBOis);
                aHasRolePolicy = new PolicyHasRole(self.WB_TPMEvent.cif.WB_CUST_ID_PLANNING);
                await aHasRolePolicy.OnLoadComplete;
                self.PolicyCollection.addPolicy("HasRole", aHasRolePolicy);

                aStdEventPolicy = new TPMEventBOStandardPolicy(self, self.EditorLock);
                await aStdEventPolicy.OnLoadComplete;
                self.PolicyCollection.addPolicy("Event", aStdEventPolicy);

                this._bIHaveSecurityLoaded = true;
                return self;
            } catch (err) {
                console.log("Unable to setup Security Policies");
                throw err;
            }
        })();

        return this._OnIHaveSecurityLoaded;
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection;
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveTPMEventMetrics operations">

    private _bIHaveTPMEventMetricsLoaded: boolean;
    private _TPMEventMetricsProgressProvider: ProgressProvider;
    private _TPMEventMetricsCollectionChanged: BehaviorSubject<IHaveTPMEventMetrics>;
    private _TPMEventMetricsPropertyChanged: BehaviorSubject<IHaveTPMEventMetricsChangedEvent>;

    private _dctPrdGrpRowQueuedById: { [id: number]: WB_ProductGroupRow };
    private _dctPrdGrpRowLoadedById: { [id: number]: WB_ProductGroupRow };
    private _bLoadAllPrdGrpsQueued: boolean;
    private _bLoadAllPrdGrpsLoaded: boolean;

    private _bQueueLoadProcessRunning: boolean;
    private _bQueueLoadProcessPaused: boolean;
    private _ProductGroupLoadProgressProvider: IProgressProvider;

    private IHaveTPMEventMetrics_init() {
        this._dctPrdGrpRowQueuedById = {};
        this._dctPrdGrpRowLoadedById = {};
        this._bLoadAllPrdGrpsQueued = false;
        this._bLoadAllPrdGrpsLoaded = false;

        this._bQueueLoadProcessRunning = false;
        this._bQueueLoadProcessPaused = false;
        this._ProductGroupLoadProgressProvider = new ProgressProvider();

        this._bIHaveTPMEventMetricsLoaded = false;
        this._TPMEventMetricsProgressProvider = new ProgressProvider();
        this._TPMEventMetricsCollectionChanged = new BehaviorSubject<IHaveTPMEventMetrics>(undefined);
        this._TPMEventMetricsPropertyChanged = new BehaviorSubject<IHaveTPMEventMetricsChangedEvent>(undefined);
    }

    private IHaveTPMEventMetrics_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            // Iterate over records and setup change events..
            _.forEach(
                _.filter(self.WB_TPMEvent.WB_TPM_EventMetricsRows, (a) => a.isActive),
                (aRow) => {
                    aRow.setupOnChangeEvents([], self.IHaveTPMEventMetrics_onRecordChange.bind(self), self);
                }
            );

            self.ProductGroupsChanged.subscribe((iHavePGs) => {
                if (_.isEmpty(iHavePGs)) {
                    return;
                }

                if (self.bIsLoaded) {
                    self.TPMEventMetricsProgressProvider.finish();
                    self.TPMEventMetricsCollectionChanged.next(self);
                }
            });

            resolve();
        });
    }

    IHaveTPMEventMetrics_beforeReload() {
        this._bIHaveTPMEventMetricsLoaded = false;

        // Reset the Queue
        this._dctPrdGrpRowQueuedById = {};
        this._dctPrdGrpRowLoadedById = {};
        this._bLoadAllPrdGrpsQueued = false;
        this._bLoadAllPrdGrpsLoaded = false;

        this._bQueueLoadProcessRunning = false;
        this._bQueueLoadProcessPaused = false;

        this.dbContext.purgeCache(esWB_TPM_Event_Metrics, this.TPMEventMetrics, {});
    }

    private IHaveTPMEventMetrics_onRecordChange(
        record: WB_TPM_EventMetricsRow,
        propertyName: string,
        propertyValue: any,
        options: IHaveTPMEventMetrics
    ) {
        this.TPMEventMetricsPropertyChanged.next({
            IHaveTPMEventMetrics: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        });
    }

    get bIHaveTPMEventMetricsLoaded(): boolean {
        return this._bIHaveTPMEventMetricsLoaded;
    }

    get OnIHaveTPMEventMetricsLoaded(): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            // Only
            let loadPromise;
            if (self.bIsLoaded) {
                loadPromise = ASync.resolve();
            } else {
                loadPromise = self.OnLoadComplete;
            }
            loadPromise
                .then(() => {
                    return self.OnIHaveProductGroupsLoaded;
                })
                /*.then(() => { return self.OnIHavePlannedPeriodsLoaded })*/
                .then(() => {
                    self._bIHaveTPMEventMetricsLoaded = true;
                    if (self.ProductGroups.length <= EventMetrics_ProductGroupLoadAllThreshold) {
                        self.loadAllProductGroups();
                    }
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    get TPMEventMetricsProgressProvider(): IProgressProvider {
        return this._TPMEventMetricsProgressProvider;
    }

    get TPMEventMetrics(): WB_TPM_EventMetricsRow[] {
        return _.filter(this.WB_TPMEvent.WB_TPM_EventMetricsRows, (a: WB_TPM_EventMetricsRow) => a.isActive);
    }

    get TPMEventMetricsCollectionChanged(): BehaviorSubject<IHaveTPMEventMetrics> {
        return this._TPMEventMetricsCollectionChanged;
    }

    get TPMEventMetricsPropertyChanged(): BehaviorSubject<IHaveTPMEventMetricsChangedEvent> {
        return this._TPMEventMetricsPropertyChanged;
    }

    // Metric Row Load Operations
    pauseLoadProcessing(): void {
        this._bQueueLoadProcessPaused = true;
    }

    resumeLoadProcessing(): void {
        this._bQueueLoadProcessPaused = false;
        this._IHaveEventMetrics_processQueue();
    }

    // Load by Product Groups
    loadProductGroups(arrWBPGIds: number[]): void {
        const self = this;

        let loadPromise = undefined;
        if (_.isEmpty(arrWBPGIds)) {
            loadPromise = ASync.resolve([]);
        } else if (_.isArray(arrWBPGIds)) {
            loadPromise = self.dbContext.findUsingCache(esWB_Product_Group, arrWBPGIds);
        } else {
            // Argument not array or empty
            return;
        }

        loadPromise
            .then((arrWB_PrdGrp_Rows: WB_ProductGroupRow[]) => {
                if (_.isEmpty(arrWB_PrdGrp_Rows)) {
                    return;
                }

                _.forEach(arrWB_PrdGrp_Rows, (aWBPrdGrpRow: WB_ProductGroupRow) => {
                    if (aWBPrdGrpRow.cif.WB_PRDGRP_ID in self._dctPrdGrpRowQueuedById) {
                        // Don't re-add it.
                    } else {
                        self._dctPrdGrpRowQueuedById[aWBPrdGrpRow.cif.WB_PRDGRP_ID] = aWBPrdGrpRow;
                    }
                });
                //self._notifyQueueChange()
                self._IHaveEventMetrics_processQueue();
            })
            .catch((err) => {
                console.log(err);
                return;
            });
    }

    loadAllProductGroups(): void {
        this._bLoadAllPrdGrpsQueued = true;
        this._IHaveEventMetrics_processQueue();
    }

    get ProductGroupsLoaded(): WB_ProductGroupRow[] {
        return _.values(this._dctPrdGrpRowLoadedById);
    }

    get ProductGroupsAllLoaded(): boolean {
        return this._bLoadAllPrdGrpsLoaded;
    }

    get ProductGroupsLoadProgressProvider(): IProgressProvider {
        return this._ProductGroupLoadProgressProvider;
    }

    private _IHaveEventMetrics_processQueue(): void {
        const self = this;
        const bDebugQueueProcessing = true;
        const bLoadIteratively = true;

        // 0. If Loading paused, exit
        // 1. If Load Running, exit
        // 2. Copy the queue
        // 3. Check if the queue is empty
        // 4. Load Volume Metrics
        // 5. Delete loaded items from the queue
        // 6. Notify addition

        if (bDebugQueueProcessing) console.log("IHaveEventMetrics_processQueue started");

        // 0. If Loading Paused, exit
        if (self._bQueueLoadProcessPaused) {
            console.log("IHaveEventMetricss_processQueue ended: paused");
            return;
        }

        // 1. If Load Running, exit
        if (self._bQueueLoadProcessRunning) {
            console.log("IHaveEventMetrics_processQueue ended: already running");
            return;
        }

        // 2. Copy the queue
        const dctPrdGrpRowByIdCurrentQueueLoad = _.clone(self._dctPrdGrpRowQueuedById);
        const bLoadAllProductGroupCurrentQueueLoad = self._bLoadAllPrdGrpsQueued || self._bLoadAllPrdGrpsLoaded;

        // Remove already loaded Items
        _.forEach(self._dctPrdGrpRowLoadedById, (value, key: any) => {
            if (key in dctPrdGrpRowByIdCurrentQueueLoad) {
                delete dctPrdGrpRowByIdCurrentQueueLoad[key];
            }
        });

        // 3. Check if the queue is empty
        if (
            _.isEmpty(dctPrdGrpRowByIdCurrentQueueLoad) &&
            bLoadAllProductGroupCurrentQueueLoad == self._bLoadAllPrdGrpsLoaded
        ) {
            self._dctPrdGrpRowQueuedById = {};
            console.log("IHaveEventMetrics_processQueue ended: empty queue");
            return;
        }

        // If All Loaded, return...
        if (self._bLoadAllPrdGrpsLoaded) {
            console.log("IHaveEventMetrics_processQueue ended: all pgs already loaded");
            return;
        }

        // Mark running
        self._bQueueLoadProcessRunning = true;
        if (bDebugQueueProcessing) console.log("IHaveEventMetrics_processQueue set Queue Running.");
        self._ProductGroupLoadProgressProvider.start("Loading Metrics");

        let arrWBPrdGrpIds = _.map(dctPrdGrpRowByIdCurrentQueueLoad, (aPrdGrpRow: WB_ProductGroupRow) => {
            return aPrdGrpRow.cif.WB_PRDGRP_ID;
        });

        // 4. Union of all queued & loaded
        let condition: any = { WB_TEVT_ID: self.WB_TPMEvent.cif.WB_TEVT_ID };

        if (!bLoadAllProductGroupCurrentQueueLoad) {
            if (_.isEmpty(arrWBPrdGrpIds)) {
                arrWBPrdGrpIds = [-99999];
            }

            condition = { and: [condition, { WB_PRDGRP_ID: { inq: arrWBPrdGrpIds } }] };
        }
        if (bDebugQueueProcessing) console.log("Queue Condition: " + JSON.stringify(condition));

        //self._ProductGroupLoadProgressProvider.setProgressDenominator(arrWBEventToLoad.length)
        // Use Record Resolver to get Parents..
        const recResolver = new ESRecordResolver(self.dbContext, {});
        recResolver
            .queryAllWithRelationships(esWB_TPM_Event_Metrics, condition)
            .then((results) => {
                if (!_.isArray(results)) {
                    if (bDebugQueueProcessing)
                        console.log("IHaveEventMetrics_processQueue set Queue Running = false, not array.");
                    self._bQueueLoadProcessRunning = false;
                    self._ProductGroupLoadProgressProvider.finish();
                    return;
                }

                // Add Event handling
                _.forEach(results, (loadRecord) => {
                    loadRecord.setupOnChangeEvents([], self.IHaveTPMEventMetrics_onRecordChange.bind(self), self);
                });

                // 5. Delete loaded items from the queue, Update Loaded List
                // dctPrdGrpRowByIdCurrentQueueLoad
                // bLoadAllProductGroupCurrentQueueLoad

                _.forEach(dctPrdGrpRowByIdCurrentQueueLoad, (aWBPrdGrpRow: WB_ProductGroupRow) => {
                    // Remove PrdGrps from Queue
                    if (aWBPrdGrpRow.cif.WB_PRDGRP_ID in self._dctPrdGrpRowQueuedById) {
                        delete self._dctPrdGrpRowQueuedById[aWBPrdGrpRow.cif.WB_PRDGRP_ID];
                    }

                    // Add to Loaded
                    if (!(aWBPrdGrpRow.cif.WB_PRDGRP_ID in self._dctPrdGrpRowLoadedById)) {
                        self._dctPrdGrpRowLoadedById[aWBPrdGrpRow.cif.WB_PRDGRP_ID] = aWBPrdGrpRow;
                    }
                });

                self._bLoadAllPrdGrpsLoaded = bLoadAllProductGroupCurrentQueueLoad;

                if (bDebugQueueProcessing)
                    console.log("IHaveEventMetrics_processQueue set Queue Running = false, done.");
                self._bQueueLoadProcessRunning = false;

                self._ProductGroupLoadProgressProvider.finish();

                self.TPMEventMetricsCollectionChanged.next(self);

                //self._notifyQueueChange()

                setTimeout(function() {
                    self._IHaveEventMetrics_processQueue();
                }, 0);
            })
            .catch((err) => {
                console.log("IHaveEventMetrics_processQueue set Queue Running = false, error.");
                self._bQueueLoadProcessRunning = false;
                self._ProductGroupLoadProgressProvider.exception(err);
            });
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveTPMEventProductMetrics operations">

    private _bIHaveTPMEventProductMetricsLoaded: boolean;
    private _TPMEventProductMetricsProgressProvider: ProgressProvider;
    private _TPMEventProductMetricsCollectionChanged: BehaviorSubject<IHaveTPMEventProductMetrics>;
    private _TPMEventProductMetricsPropertyChanged: BehaviorSubject<IHaveTPMEventProductMetricsChangedEvent>;
    private _qsTPMEventProductMetrics_sync: ExecutionSerializer;

    private _dctPrdRowQueuedById: { [id: number]: WB_FinishedProductRow };
    private _dctPrdRowLoadedById: { [id: number]: WB_FinishedProductRow };
    private _bLoadAllPrdsQueued: boolean;
    private _bLoadAllPrdsLoaded: boolean;

    private _ProductLoadProgressProvider: IProgressProvider;

    private IHaveTPMEventProductMetrics_init() {
        this._bIHaveTPMEventProductMetricsLoaded = false;
        this._TPMEventProductMetricsProgressProvider = new ProgressProvider();
        this._TPMEventProductMetricsCollectionChanged = new BehaviorSubject<IHaveTPMEventProductMetrics>(undefined);
        this._TPMEventProductMetricsPropertyChanged = new BehaviorSubject<IHaveTPMEventProductMetricsChangedEvent>(
            undefined
        );
        this._qsTPMEventProductMetrics_sync = new ExecutionSerializer(
            this,
            this._ProductMetrics_synchronize.bind(this),
            [{}],
            250,
            false
        );
    }

    get ProductsLoadProgressProvider(): IProgressProvider {
        return this._ProductLoadProgressProvider;
    }

    get Products(): WB_FinishedProductRow[] {
        return;
    }

    get ProductsLoaded(): WB_FinishedProductRow[] {
        return;
    }

    get ProductsAllLoaded(): boolean {
        return this._bLoadAllPrdsLoaded;
    }

    /*
       private IHaveTPMEventProductMetrics_OnLoadComplete(): Promise<void> {
           const self = this

           return new Promise<void>((resolve, error) => {
               // Iterate over records and setup change events..
               _.forEach(_.filter(self.WB_TPMEvent.WB_TPM_EventProductMetricsRows, (a) => a.isActive), (aRow) => {
                   aRow.setupOnChangeEvents([], self.IHaveTPMEventProductMetrics_onRecordChange.bind(self), self)
               })

               self.TPMEventProductCollectionChanged.subscribe((iHavePrds) => {
                   if (_.isEmpty(iHavePrds)) {
                       return
                   }

                   if (self.bIsLoaded) {
                       self.TPMEventProductMetricsProgressProvider.finish()
                       self.TPMEventProductMetricsCollectionChanged.next(self)
                   }
               })

               resolve()
           })
       }
   */
    IHaveTPMEventProductMetrics_beforeReload() {
        this._bIHaveTPMEventProductMetricsLoaded = false;

        // Reset the Queue
        this._dctPrdRowQueuedById = {};
        this._dctPrdRowLoadedById = {};
        this._bLoadAllPrdsQueued = false;
        this._bLoadAllPrdsLoaded = false;

        this._bQueueLoadProcessRunning = false;
        this._bQueueLoadProcessPaused = false;
    }

    private IHaveTPMEventProductMetrics_onRecordChange(
        record: WB_TPM_EventProductMetricsRow,
        propertyName: string,
        propertyValue: any,
        options: IHaveTPMEventProductMetrics
    ) {
        this.TPMEventProductMetricsPropertyChanged.next({
            IHaveTPMEventProductMetrics: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        });
    }

    get bIHaveTPMEventProductMetricsLoaded(): boolean {
        return this._bIHaveTPMEventProductMetricsLoaded;
    }

    get OnIHaveTPMEventProductMetricsLoaded(): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            // Only
            let loadPromise;
            if (self.bIsLoaded) {
                loadPromise = ASync.resolve();
            } else {
                loadPromise = self.OnLoadComplete;
            }
            loadPromise
                .then(() => {
                    self.TPMEventPropertyChanged.subscribe((evt) => {
                        if (_.isEmpty(evt)) return;
                        switch (evt.PropertyChanged) {
                            case "SHIPMENT_START_DT":
                            case "SHIPMENT_END_DT":
                                self.ProductMetrics_synchronize();
                                break;
                        }
                    });
                    self._bIHaveTPMEventProductMetricsLoaded = true;
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    ProductMetrics_synchronize(): void {
        //  debounce calls ...
        // console.log("Synchronizing Metrics: qsRun");
        this._qsTPMEventProductMetrics_sync.Run({});
    }

    private _ProductMetrics_synchronize(): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            // console.log("Synchronizing Product Metrics: running");
            self.TPMEventProductMetricsProgressProvider.start("Synchronizing Product Metrics");

            // This API checks itself if it's loaded... and tries to load..
            let loadPromise: Promise<void>;
            if (self.bIHaveTPMEventProductMetricsLoaded) {
                loadPromise = ASync.resolve();
            } else {
                loadPromise = self.OnIHaveTPMEventProductMetricsLoaded;
            }

            loadPromise
                .then(() => {
                    return self.getProductMetricsPeriods();
                })
                .then((arrPeriods: WB_PeriodRow[]) => {
                    const dctPeriodsByKey = _.keyBy(
                        arrPeriods,
                        (aPeriodRow: WB_PeriodRow) => aPeriodRow.cif.WB_PERIOD_ID
                    );
                    // Determine the Products & Weeks... and create sync the combination of records..
                    let arrDisplayProducts: WB_TPM_EventProductRow[] = []; // self.ProductGroups
                    arrDisplayProducts = _.filter(
                        self.WB_TPMEvent.WB_TPM_EventProductRows,
                        (aRow: WB_TPM_EventProductRow) => aRow.cif.ROW_TYPE == "Display" && aRow.isActive
                    );
                    const dctDisplayProducts = _.keyBy(arrDisplayProducts, (aPrd) => aPrd.cif.WB_PROD_ID);

                    const dctProductMetrics: { [id: string]: WB_TPM_EventProductMetricsRow } = {};

                    // Create Dictionary... deleting duplicate rows, and rows not in scope
                    _.forEach(self.TPMEventProductMetrics, (aRow) => {
                        // Check if the Product or Period isn't in the dataset
                        if (!(aRow.cif.WB_PROD_ID in dctDisplayProducts)) {
                            // Remove extra Product Group
                            aRow.markDeleted();
                            return;
                        }

                        if (!(aRow.cif.WB_PERIOD_ID in dctPeriodsByKey)) {
                            // Remove extra Period
                            aRow.markDeleted();
                            return;
                        }

                        const logicalKey = aRow.cif.WB_PROD_ID + "-" + aRow.cif.WB_PERIOD_ID;

                        if (logicalKey in dctProductMetrics) {
                            // Remove Duplicate Row
                            aRow.markDeleted();
                            return;
                        }

                        dctProductMetrics[logicalKey] = aRow;
                    });

                    async function createMissingRecords() {
                        // get Period Records from this dbContext..

                        for (let idxPrd = 0; idxPrd < arrDisplayProducts.length; idxPrd++) {
                            for (let idxPeriod = 0; idxPeriod < arrPeriods.length; idxPeriod++) {
                                const aProductRow = arrDisplayProducts[idxPrd];
                                const aPeriodRow = arrPeriods[idxPeriod];

                                const logicalKey = aProductRow.cif.WB_PROD_ID + "-" + aPeriodRow.cif.WB_PERIOD_ID;
                                if (logicalKey in dctProductMetrics) {
                                    continue;
                                }

                                // Create Missing Record.. add to Dictionary.
                                const newRecord: WB_TPM_EventProductMetricsRow = await self.addTPMEventProductMetric(
                                    aProductRow.cif.WB_PROD_ID,
                                    aPeriodRow.cif.WB_PERIOD_ID,
                                    {}
                                );

                                // Add Event handling
                                newRecord.setupOnChangeEvents(
                                    [],
                                    self.IHaveTPMEventProductMetrics_onRecordChange.bind(self),
                                    self
                                );
                            }
                        }
                    }

                    return createMissingRecords();
                })
                .then(() => {
                    self.TPMEventProductMetricsProgressProvider.finish();
                    self.TPMEventProductMetricsCollectionChanged.next(self);
                    resolve();
                })
                .catch((err) => {
                    self.TPMEventProductMetricsProgressProvider.exception(err);
                    self.TPMEventProductMetricsCollectionChanged.next(self);
                    error(err);
                });
        });
    }

    addTPMEventProductMetric(
        wb_prod_id: number,
        wb_period_Id: number,
        options: any
    ): Promise<WB_TPM_EventProductMetricsRow> {
        const self = this;
        const opts: any = {};
        _.defaults(opts, options, ITPMEventProductsAddOptionsDefaults);

        return new Promise<WB_TPM_EventProductMetricsRow>((resolve, error) => {
            self.dbContext
                .findUsingCache(esWB_Period, [wb_period_Id])
                .then(() => {
                    return self.dbContext.findUsingCache(esWB_Finished_Product, [wb_prod_id]);
                })
                .then(() => {
                    return self.dbContext.createRecordWithKey(esWB_TPM_Event_Product_Metrics);
                })
                .then((aNewRow: WB_TPM_EventProductMetricsRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_TEVT_ID = self.WB_TPMEvent.cif.WB_TEVT_ID;
                    aNewRow.cif.WB_PROD_ID = wb_prod_id;
                    aNewRow.cif.WB_PERIOD_ID = wb_period_Id;
                    aNewRow.cif.ROW_TYPE = "Display";

                    self.dbContext.add(esWB_TPM_Event_Product_Metrics, aNewRow);
                    resolve(aNewRow);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    removeTPMEventProductMetric(aWB_TEVTPRDMT_ID: number | number[], options?: any): Promise<void> {
        const self = this;
        const opts = options || {};

        return new Promise<void>((resolve, error) => {
            let arrWB_TEVTPRDMT_ID: number[] = [];

            if (_.isArray(aWB_TEVTPRDMT_ID)) {
                arrWB_TEVTPRDMT_ID = aWB_TEVTPRDMT_ID;
            } else {
                arrWB_TEVTPRDMT_ID = [aWB_TEVTPRDMT_ID];
            }

            const arrPrdRows = _.filter(
                self.WB_TPMEvent.WB_TPM_EventProductMetricsRows,
                (aRow: WB_TPM_EventProductMetricsRow) =>
                    aRow.isActive && _.includes(arrWB_TEVTPRDMT_ID, aRow.cif.WB_TEVTPRDMT_ID)
            );

            _.forEach(arrPrdRows, (aRow: WB_TPM_EventProductMetricsRow) => {
                aRow.markDeleted();
            });

            self.TPMEventProductMetricsCollectionChanged.next(self);
            resolve();
            return;
        });
    }

    private getProductMetricsPeriods(): Promise<WB_PeriodRow[]> {
        const self = this;
        return new Promise<WB_PeriodRow[]>((resolve, error) => {
            PeriodService.getPeriodsByPeriodTypeWbIDDateRange(
                self.WB_TPMEvent.WB_PlanRow.WB_PlanTypeRow.cif.WB_PERIODM_ID,
                DateUtils.convertFromSAPBW(self.WB_TPMEvent.cif.SHIPMENT_START_DT),
                DateUtils.convertFromSAPBW(self.WB_TPMEvent.cif.SHIPMENT_END_DT)
            ).then((WB_PeriodRows: WB_PeriodRow[]) => {
                resolve(WB_PeriodRows);
            });
        });
    }

    get TPMEventProductMetricsProgressProvider(): IProgressProvider {
        return this._TPMEventProductMetricsProgressProvider;
    }

    get TPMEventProductMetrics(): WB_TPM_EventProductMetricsRow[] {
        return _.filter(
            this.WB_TPMEvent.WB_TPM_EventProductMetricsRows,
            (a: WB_TPM_EventProductMetricsRow) => a.isActive
        );
    }

    get TPMEventProductMetricsCollectionChanged(): BehaviorSubject<IHaveTPMEventProductMetrics> {
        return this._TPMEventProductMetricsCollectionChanged;
    }

    get TPMEventProductMetricsPropertyChanged(): BehaviorSubject<IHaveTPMEventProductMetricsChangedEvent> {
        return this._TPMEventProductMetricsPropertyChanged;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveWorkflow operations">

    private _WorkflowProcessors: IWorkflowProcessor[];
    private _PrimaryWorkflowProcessor: IWorkflowProcessor;

    private IHaveWorkflow_init(): void {
        this._WorkflowProcessors = [];
        this._PrimaryWorkflowProcessor = undefined;
    }

    private IHaveWorkflow_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            // Reset Workflow Processors

            self._WorkflowProcessors = [];
            const aWorkflowProcessor = new WorkflowProcessor(self.WB_TPMEvent.WB_EventTypeRow.cif.WB_WORKFLOW_ID, {
                dbContext: self.dbContext,
                AppMgr_Id: "Event",
                WB_App_Id: self.WB_TPMEvent.cif.WB_TEVT_ID,
                App_Id: self.WB_TPMEvent.cif.EVENT_ID,
                bLoadWorkflowHistory: true,
                bLoadUserReviewers: false,
                WB_Cust_Id: self.WB_TPMEvent.cif.WB_CUST_ID_PLANNING,
                object: self,
                Record: self.WB_TPMEvent,
                CurrentStateIdFieldName: "WORKFLOW_STATUS_ID",
                NextStateIdFieldName: "WORKFLOW_STATUS_ID_NEXT",
                NextUserIdFieldName: "WB_AUTHUSR_ID_WF_NEXT",
                OwnerUserIdFieldName: "WB_AUTHUSR_ID_CREATEDBY"
            });
            const StdExtension = new TPMEventBOStandardWorkflowExtension(self);
            aWorkflowProcessor.setExtensions([StdExtension]);
            self._PrimaryWorkflowProcessor = aWorkflowProcessor;
            self.PolicyCollection.addPolicy("Workflow", aWorkflowProcessor);

            aWorkflowProcessor.OnLoadComplete.then(() => {
                self._WorkflowProcessors.push(aWorkflowProcessor);
                resolve();
            }).catch((err) => {
                error(err);
            });
        });
    }

    private IHaveWorkflow_BeforeReload(): void {
        this._WorkflowProcessors = [];
        this._PrimaryWorkflowProcessor = undefined;
    }

    get WorkflowProcessors(): IWorkflowProcessor[] {
        return this._WorkflowProcessors;
    }

    get PrimaryWorkflowProcessor(): IWorkflowProcessor {
        return this._PrimaryWorkflowProcessor;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSpendHistory operations">

    private _SpendInitialState: ITPMSpendState = {};

    IHaveSpendHistory_init() {
        this._SpendInitialState = {};
    }

    private IHaveSpendHistory_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            this._SpendInitialState = SpendHistory_get(self);
            resolve();
        });
    }

    private IHaveSpendHistory_BeforeReload(): void {
        this._SpendInitialState = {};
    }

    get SpendInitialState(): ITPMSpendState {
        return this._SpendInitialState;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveEditorLock">
    get EditorLock(): ILock {
        return this._Lock;
    }

    //<editor-fold desc = "IHaveRefCounter">
    private _refCounter: IRefCounter;
    private _refCounterSub: Subscription;

    RefCounter_Init(): void {
        this._refCounter = new RefCounter(this);
        this._refCounterSub = this.RefCounter.OnRefCounterChanged.subscribe(this.onRefCounterChanged.bind(this));
    }

    get RefCounter(): IRefCounter {
        return this._refCounter;
    }

    private onRefCounterChanged(event: { refCounter: IRefCounter; count: number }): void {
        if (this.RefCounter.RefCount > 0) return;

        if (_.isEmpty(this.EditorLock)) return;

        if (this.EditorLock.Status === "Locked") this.EditorLock.release();
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolverProvider   <<STATIC>> operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        const opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ("dbContext" in opts) dbContext = opts.dbContext;
        else {
            dbContext = new PAdbContext({});
        }
        const evt_options: CreateOptions = {
            standardConditions: {
                [esWB_TPM_Event]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_TPM_Event_Product_Group]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_TPM_Event_Product]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_TPM_Event_Product_Metrics]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_TPM_Event_Spend]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_TPM_Event_Spend_Product_Group]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_TPM_Event_Spend_Customer]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_TPM_Event_Spend_Product]: { DELETED_IND: { notIn: ["1"] } }
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_TPM_Event]: [esWB_TPM_Event_Metrics],
                [esWB_TPM_Event_Spend]: [esWB_TPM_Event_Spend_Metrics]
            },
            dctIncludeBelongsToNamedRelations: {
                // This should match LoadNew loadRelations
                [esWB_Event_Type]: [esWB_Tag, esWB_Product_Hierarchy],
                [esWB_Plan]: [esWB_Plan_Type, esWB_Customer, esWB_Product_Group, esWB_Period, esWB_Plan_Management]
            }
        };

        const aRecResolver = new ESRecordResolver(dbContext, evt_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver
                .findAllWithRelationships(esWB_TPM_Event, ids)
                .then((result) => {
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    static concurrentLoadCountHint(): number {
        return 5;
    }

    //</editor-fold>
}

PAEnvironment.registerBusinessObjectClass(TPMEventBO, "TPMEventBO", "TPM Event");
